import {
  Accordion,
  AccordionSummary,
  Box,
  Divider,
  Modal,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format } from "date-fns";

import {
  bankDropdown,
  bloodGroupDropdown,
  classificationDropdown,
  degreeDropdown,
  designationDropdown,
  doctorTypeDropdown,
  maritalStatusDropdown,
  motherTonghDropdown,
  prefixDropdown,
  referEntityDropdown,
  religionDropdown,
  specializationDropdown,
  subSpecializationDropdown,
} from "../../../services/referalDoctor/ReferalDoctorServices";
import {
  departmentDropdown,
  genderDropDown,
  relationDropdown,
  unitDropDown,
} from "../../../../commonServices/CommonService";
import {
  areaDropDown,
  cityDropDown,
  countryDropDown,
  districtDropDown,
  stateDropDown,
  talukaDropDown,
} from "../../areas/area/AreaServices";
import {
  departmentDropdownList,
  departmentDropdownSearch,
  occupationDropdown,
  postDoctor,
} from "../../../services/employee/DoctorService";

import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import InputField from "../../../../common/components/FormFields/InputField";
import CheckBoxField from "../../../../common/components/FormFields/CheckBoxField";
import DatePickerField from "../../../../common/components/FormFields/DatePickerFieldNew";
import InputLimit from "../../../../common/components/FormFields/InputLimit";
import { errorAlert, successAlert, warningAlert } from "../../../../common/components/Toasts/CustomToasts";
import SearchDropdown from "../../../../common/components/FormFields/searchDropdown";
import CommonDynamicTableNew from "../../../../common/components/CommonTable/CommonDynamicTableNew";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import CommonBackDrop from "../../../../common/components/CommonBackDrop/CommonBackDrop";
import RadioField from "../../../../common/components/FormFields/RadioField";
import DropdownField from "../../../../common/components/FormFields/DropdownField";
import { getBirthDateAPI } from "../../../services/employee/EmployeeService";
import { Photo, Sign } from "../../../../assets/CommonAssets";

export const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  // height:"90%",
  bgcolor: "background.paper",
  border: "1px solid gray",
  borderRadius: 1,
  boxShadow: 20,
  "&::-webkit-scrollbar": {
    width: 7,
    height: 10,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "lightBlue",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#1e3a8a",
  },
};
const staffoption = [
  {
    id: "staff",
    value: "staff",
    label: "Staff",
  },
  {
    id: "Polyclinic",
    value: "Polyclinic",
    label: "Polyclinic",
  },
  {
    id: "Nursing",
    value: "Nursing",
    label: "Nursing",
  },
];

const accountType = [
  {
    id: "saving",
    value: "saving",
    label: "Saving",
  },
  {
    id: "current",
    value: "current",
    label: "Current",
  },
];
const MedicalAllowance = [
  {
    id: "yes",
    value: "yes",
    label: "Yes",
  },
  {
    id: "no",
    value: "no",
    label: "No",
  },
];

export default function DoctorModel(props) {
  const inputFile = useRef(null);
  const [file, setFile] = useState();
  const [uploadfile, setUploadFile] = useState();
  const [countryOption, setCountryOption] = useState([]);
  const [prefixOption, setPrefixOption] = useState([]);
  const [religionOption, setReligionOption] = useState([]);
  const [motherTonghOption, setMotherTonghOption] = useState([]);
  const [designationOption, setDesignationOptions] = useState([]);
  const [classificationOption, setClassificationOption] = useState([]);
  const [doctorTypeOption, setDoctorTypeOption] = useState([]);
  const [subSpecializationOption, setSubSpecializationOption] = useState([]);
  const [degreeOption, setDegreeOption] = useState([]);
  const [bankOption, setBankOption] = useState([]);
  const [countryId, setCountryId] = useState();
  const [stateOption, setStateOption] = useState([]);
  const [stateId, setStateId] = useState();
  const [districtOption, setDistrictOption] = useState([]);
  const [districtId, setDistrictId] = useState();
  const [cityOption, setCityOption] = useState([]);
  const [cityId, setCityId] = useState();
  const [talukaOption, setTalukaOption] = useState([]);
  const [talukaId, setTalukaId] = useState();
  const [areaOption, setAreaOption] = useState([]);
  const [finalData, setFinalData] = React.useState();
  const [openPost, setOpenPost] = React.useState(false);
  const [openPut, setOpenPut] = React.useState(false);
  const [unitOption, setUnitOption] = React.useState([]);
  const [bloodGroupOption, setbloodGroupOption] = useState([]);
  const [maritalStatusOption, setMaritalStatusOption] = useState([]);
  const [referEntityOption, setReferalEntityOption] = useState([]);
  const [specializationOption, setSpecializationOption] = useState([]);
  const [genderOption, setGenderOption] = React.useState([]);
  const [relationOption, setRelationOption] = useState([]);
  const [occupationOption, setOccupationOption] = useState([]);
  const [departmentOption, setDepartMentOption] = useState([]);
  const [eduData, setEduData] = useState([]);
  const [experienceData, setExperienceData] = useState([]);
  const [dependentData, setDependentData] = useState([]);
  const [photoData, setPhotoData] = useState();
  const [signData, setSignData] = useState();

  const handleClosePut = () => {
    if (openPut) {
      setOpenPut(false);
    }
  };

  const handleClosePost = () => {
    if (openPost) {
      setOpenPost(false);
    }
  };
  const schema = yup.object().shape({
    firstName: yup.string().required("Required"),
    lastName: yup.string().required("Required"),
    address: yup.string().required("Required"),
    emailID: yup.string().email().required(),
    mobileNo: yup
      .string()
      .matches(/^[0-9]+$/, "Please Provide Valid Mobile No.")
      .min(10, "Please Provide Valid Mobile No.")
      .max(14, "Please Provide Valid Mobile No.")
      .required("Please Provide Valid Mobile No."),
    panNo: yup
      .string()
      .matches(/[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Required ")
      .min(10, "Please Provide Valid Pan No.")
      .max(10, "Please Provide Valid Pan No.")
      .required("Required"),
    IFSCCode: yup
      .string()
      .matches(/^[A-Z]{4}0[0-9]{6}$/, "Required ")
      .min(11, "Please Provide Valid IFSC Code.")
      .max(11, "Please Provide Valid IFSC Code.")
      .required("Required"),

    privateClinicContactNo: yup
      .string()
      .matches(/^[0-9]+$/, "Please Provide Valid Mobile No.")
      .min(10, "Please Provide Valid Mobile No.")
      .max(14, "Please Provide Valid Mobile No.")
      .required("Please Provide Valid Mobile No."),
    telephoneNo: yup
      .string()
      .matches(/^[0-9]+$/, "Please Provide Valid Mobile No.")
      .min(10, "Please Provide Valid Mobile No.")
      .max(14, "Please Provide Valid Mobile No.")
      .required("Please Provide Valid Mobile No."),

    pinCode: yup.string().test((val) => {
      if (val !== "0") return val?.length === 6;
    }),
    localPinCode: yup.string().test((val) => {
      if (val !== "0") return val?.length === 6;
    }),
  });

  const commonDatePickerSx = {
    backgroundColor: "white",

    "& .MuiOutlinedInput-root": {
      height: "40px",
    },

    "& .MuiOutlinedInput-input": {
      padding: "10px 12px", // ✅ THIS centers text
      fontSize: "14px",
      boxSizing: "border-box",
    },

    "& .MuiInputLabel-root": {
      fontSize: "13px",
    },

    "& .MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)", // ✅ proper label position
    },

    "& svg": {
      fontSize: 20,
      color: "#1E3A8A",
    },
  };


  const defaultValues = {
    status: false,
    unit: null,
    unitClassification: null,
    unitDepartment: null,
    unitMainDepartment: null,
    unitSubDepartment: null,
    privateOPD: false,
    OPD: false,
    IPD: false,
    investigation: false,
    noReference: false,
    procedure: false,
    mahRenewalDate: null,
    renewalDate: null,
    dateofBirth: null,
    dateOfJoining: null,
    dateOfAnniversary: new Date(),
    fromDate: null,
    toDate: null,
    dateOfBirths: null,
    Medical: "",
    doctorCode: "",
    prefix: null,
    firstName: "",
    middleName: "",
    lastName: "",
    yy: "",
    mm: "",
    dd: "",
    religion: null,
    motherTongh: null,
    bloodGroup: null,
    maritalStatus: null,
    ClinicName: "",
    panNo: "",
    telephoneNo: "",
    mobileNo: "",
    emailID: "",
    passportNo: "",
    regNo: "",
    mahRegNo: "",
    designation: null,
    classification: null,
    doctorType: null,
    specialization: null,
    subSpecialization: null,
    address: "",
    country: null,
    state: null,
    district: null,
    pinCode: "",
    city: null,
    area: null,
    addresslocal: false,
    localaddress: "",
    localCountry: null,
    localState: null,
    localDistrict: null,
    localPinCode: "",
    localCity: null,
    localArea: null,
    privateClinicContactNo: "",
    privateClinicAddress: "",
    degree: null,
    yearofPassing: "",
    university: "",
    classMarks: "",
    printApplicable: false,
    experienceyy: "",
    experiencemm: "",
    lastSalaryDrawn: "",
    postHeld: "",
    company: "",
    reasonForleaving: "",
    BankName: null,
    branchName: "",
    ACNo: "",
    IFSCCode: "",
    accountType: "",
    dependentFirstName: "",
    dependentMiddleName: "",
    dependentLastName: "",
    dependentGender: null,
    dependentAge: "",
    dependentRelation: null,
    dependentOccupation: null,
    taluka: null,
    localtaluka: null,
  };
  const {
    control,
    handleSubmit,
    watch,
    register,
    setValue,
    setError,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: defaultValues,
  });

  const onError = (errors) => {
    const firstKey = Object.keys(errors)[0];

    // convert camelCase → words
    let fieldName = firstKey.replace(/([A-Z])/g, " $1");

    // capitalize first letter of each word
    fieldName = fieldName
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    errorAlert(`${fieldName} is required`);
  };

  let experienceyyWatch = watch("experienceyy");
  let experiencemmWatch = watch("experiencemm");
  let lastSalaryDrawneWatch = watch("lastSalaryDrawn");
  let postHeldWatch = watch("postHeld");
  let companyWatch = watch("company");
  let reasonForleavingWatch = watch("reasonForleaving");
  let degreeWatch = watch("degree");
  let yearofPassingWatch = watch("yearofPassing");
  let universityWatch = watch("university");
  let classMarksWatch = watch("classMarks");
  let printApplicableWatch = watch("printApplicable");
  let dependentFirstNameWatch = watch("dependentFirstName");
  let dependentMiddleNameWatch = watch("dependentMiddleName");
  let dependentLastNameWatch = watch("dependentLastName");
  let dependentGenderWatch = watch("dependentGender");
  let dependentAgeWatch = watch("dependentAge");
  let dependentRelationWatch = watch("dependentRelation");
  let dependentOccupationWatch = watch("dependentOccupation");
  let MedicalWatch = watch("Medical");
  let addressWatch = watch("address");
  let countryWatch = watch("country");
  let stateWatch = watch("state");
  let districtWatch = watch("district");
  let talukaWatch = watch("taluka");
  let cityWatch = watch("city");
  let AreaWatch = watch("area");
  let pinCodeWatch = watch("pinCode");
  let dateofBirthWatch = watch("dateofBirth");
  let fromDateWatch = watch("fromDate");
  let toDateWatch = watch("toDate");
  let dateOfBirthsWatch = watch("dateOfBirths");
  let UnitWatch = watch("unit");
  let renewalDateWatch = watch("renewalDate");
  let mahRenewalDateWatch = watch("mahRenewalDate");
  let dateOfAnniversaryWatch = watch("dateOfAnniversary");
  let dateOfJoiningWatch = watch("dateOfJoining");
  let unitClassificationWatch = watch("unitClassification");
  let unitDepartmentWatch = watch("unitDepartment");

  let StaffWatch = watch("Staff");
  let accountTypeWatch = watch("accountType");
  let account;
  if (accountTypeWatch === "saving") {
    account = "S";
  } else if (accountTypeWatch === "current") {
    account = "C";
  }

  let clinic;
  if (StaffWatch === "staff") {
    clinic = "0";
  } else if (StaffWatch === "polyclinic") {
    clinic = "1";
  } else if (StaffWatch === "nursing") {
    clinic = "2";
  }

  //PrinApp Function
  let printApp;
  if (printApplicableWatch === false) {
    printApp = "No";
  } else if (printApplicableWatch === true) {
    printApp = "Yes";
  }

  //Medical
  let MedicalVal;
  if (MedicalWatch === "yes") {
    MedicalVal = "Y";
  } else if (MedicalWatch === "no") {
    MedicalVal = "N";
  }

  //Render Action Eduction
  const RenderActions = (row, index, header) => {
    return (
      <div className="flex ">
        <div>
          <Tooltip title="Delete">
            <a
              href="##"
              className="text-red-500 mr-3"
              onClick={() => {
                deleteRecord(index, (header = "eduData"));
              }}
            >
              {<DeleteOutlineOutlinedIcon />}
            </a>
          </Tooltip>
        </div>
      </div>
    );
  };

  //Render Action Experience
  const RenderActionsExp = (row, index, header) => {
    return (
      <div className="flex ">
        <div>
          <Tooltip title="Delete">
            <a
              href="##"
              className="text-red-500 mr-3"
              onClick={() => {
                deleteRecord(index, (header = "expData"));
              }}
            >
              {<DeleteOutlineOutlinedIcon />}
            </a>
          </Tooltip>
        </div>
      </div>
    );
  };

  //Render Action Dependent
  const RenderActionsDep = (row, index, header) => {
    return (
      <div className="flex ">
        <div>
          <Tooltip title="Delete">
            <a
              href="##"
              className="text-red-500 mr-3"
              onClick={() => {
                deleteRecord(index, (header = "depData"));
              }}
            >
              {<DeleteOutlineOutlinedIcon />}
            </a>
          </Tooltip>
        </div>
      </div>
    );
  };

  console.log("errors", errors);

  //File Uploaded Function
  // const handleChange = (e) => {
  //   let arr = e.target.files;
  //   let imageUrl = URL.createObjectURL(e.target.files[0]);
  //   // let documentsArr = [...file];
  //   for (let obj of arr) {
  //     console.log("objobjobjobjobjobj", obj);
  //     let object = {};
  //     object.fileName = obj.name;
  //     object.size = obj.size;
  //     let reader = new FileReader();
  //     reader.readAsDataURL(obj);
  //     reader.onload = function () {
  //       let string = reader.result
  //         .toString()
  //         .replace("data:image/png;base64,", "");
  //       object.base64 = string;
  //       setFile(string);
  //     };
  //   }
  // };

  // //Signture Uploaded Function
  // const handleChangeClick = (e) => {
  //   let arr = e.target.files;
  //   let imageUrl = URL.createObjectURL(e.target.files[0]);
  //   // let documentsArr = [...file];
  //   for (let obj of arr) {
  //     console.log("objobjobjobjobjobj", obj);
  //     let object = {};
  //     object.fileName = obj.name;
  //     object.size = obj.size;
  //     let reader = new FileReader();
  //     reader.readAsDataURL(obj);
  //     reader.onload = function () {
  //       let string = reader.result
  //         .toString()
  //         .replace("data:image/png;base64,", "");
  //       object.base64 = string;
  //       setUploadFile(string);
  //     };
  //   }
  // };


  const handleChange = (e) => {
    const files = e.target.files;

    if (!files || files.length === 0) return; // ✅ FIX

    let imageUrl = URL.createObjectURL(files[0]);
    setFile(imageUrl);

    for (let obj of files) {
      let object = {
        empPhotoName: obj.name,
        size: obj.size,
      };

      let reader = new FileReader();

      reader.onload = function () {
        let base64 = "";

        if (typeof reader.result === "string") {
          base64 = reader.result.replace("data:image/png;base64,", "");
        }

        object.empPhotoBase64 = base64;
        setPhotoData(object);
      };

      reader.readAsDataURL(obj);
    }
  };

  const handleChangeClick = (e) => {
    const files = e.target.files;

    if (!files || files.length === 0) return; // ✅ FIX

    let imageUrl = URL.createObjectURL(files[0]);
    setUploadFile(imageUrl);

    for (let obj of files) {
      let object = {
        empSignName: obj.name,
        size: obj.size,
      };

      const reader = new FileReader();

      reader.onload = function () {
        if (!reader.result) return;
        let base64 = "";

        if (typeof reader.result === "string") {
          base64 = reader.result.replace("data:image/png;base64,", "");
        }

        object.empSignBase64 = base64;
        setSignData(object);
      };

      reader.readAsDataURL(obj);
    }
  };

  //Cal the birthDate age Year,month,Day API
  // const getAgeDOB = (e) => {
  //   let dobValue = e;
  //   let dobGivenYear = dobValue.getFullYear();
  //   let dobGivenMonth = String(dobValue.getMonth() + 1).padStart(2, "0");
  //   let dobGivenDay = String(dobValue.getDate()).padStart(2, "0");
  //   let fullDOB = [dobGivenYear, dobGivenMonth, dobGivenDay].join("-");

  //   getBirthDateAPI(0, fullDOB).then((response) => {
  //     setValue("yy", response.data.result.years);
  //     setValue("mm", response.data.result.months);
  //     setValue("dd", response.data.result.days);
  //   });
  // };

  const getAgeDOB = (e) => {
    // ✅ STRICT CHECK
    if (!e || !(e instanceof Date) || isNaN(e.getTime())) {
      console.log("Invalid date:", e);
      return;
    }

    // ✅ SAFE FORMAT (NO ISO BUG)
    const year = e.getFullYear();
    const month = String(e.getMonth() + 1).padStart(2, "0");
    const day = String(e.getDate()).padStart(2, "0");

    const fullDOB = `${year}-${month}-${day}`;

    console.log("DOB SENT:", fullDOB);


    if (fullDOB.includes("NaN") || fullDOB.startsWith("0")) {
      console.log("Blocked invalid DOB:", fullDOB);
      return;
    }

    getBirthDateAPI(0, fullDOB)
      .then((response) => {
        const result = response?.data?.result;

        if (!result) {
          console.error("API returned null:", response);
          return;
        }

        setValue("yy", result.ageYear ?? 0);
        setValue("mm", result.ageMonth ?? 0);
        setValue("dd", result.ageDays ?? 0);

      })
      .catch((err) => {
        console.error("API ERROR:", err);
      });
  };

  // Count The Experience  Year And Month
  var df = new Date(fromDateWatch);
  var dt = new Date(toDateWatch);
  var allMonths =
    dt.getMonth() - df.getMonth() + 12 * (dt.getFullYear() - df.getFullYear());
  var allYears = dt.getFullYear() - df.getFullYear();
  var partialMonths = dt.getMonth() - df.getMonth();
  if (partialMonths < 0) {
    allYears--;
    partialMonths = partialMonths + 12;
  }
  var total = allYears;
  var totalMonths = partialMonths;

  //useEffect Cal the Exp Year and Exp Month
  useEffect(() => {
    setValue("experienceyy", total);
    setValue("experiencemm", totalMonths);
  }, [fromDateWatch, toDateWatch]);



  //Post Object Eduction
  const handleEduOnSubmit = () => {
    if (
      degreeWatch === null &&
      yearofPassingWatch === "" &&
      universityWatch === "" &&
      classMarksWatch === ""
    ) {
      setError("degree", { type: "custom", message: "custom message" });
      setError("yearofPassing", { type: "custom", message: "custom message" });
      setError("university", { type: "custom", message: "custom message" });
      setError("classMarks", { type: "custom", message: "custom message" });
    } else if (degreeWatch === null) {
      setError("degree", { type: "custom", message: "custom message" });
    } else if (yearofPassingWatch === "") {
      setError("yearofPassing", { type: "custom", message: "custom message" });
    } else if (universityWatch === "") {
      setError("university", { type: "custom", message: "custom message" });
    } else if (classMarksWatch === "") {
      setError("classMarks", { type: "custom", message: "custom message" });
    }
    if (
      degreeWatch !== null &&
      yearofPassingWatch !== "" &&
      universityWatch !== "" &&
      classMarksWatch !== ""
    ) {
      let eduarr = [...eduData];
      let obj = {
        qualificationId: degreeWatch.id,
        qualificationDec: degreeWatch.label,
        yearPassing:
          Number(yearofPassingWatch) !== "" ? Number(yearofPassingWatch) : 0,
        university: universityWatch,
        classOrMarks: classMarksWatch,
        printApplicable: printApplicableWatch,
        printAppValue: printApp,
      };

      const eduAlreadyExists = eduData.some(
        (item) =>
          item["yearOfPassing"] === obj["yearOfPassing"] &&
          item["university"] === obj["university"] &&
          item["qualificationDec"] === obj["qualificationDec"]
      );

      if (!eduAlreadyExists) {
        eduarr.push(obj);
        handleExpReset();
      } else if (eduAlreadyExists) {
        warningAlert("Record Already Exist");
      }

      setEduData(eduarr);
    }
  };

  //Post Obj Experience
  const handleExperienceonSubmit = () => {
    if (
      experienceyyWatch === "" &&
      experiencemmWatch === "" &&
      lastSalaryDrawneWatch === "" &&
      postHeldWatch === "" &&
      companyWatch === "" &&
      reasonForleavingWatch === ""
    ) {
      setError("experienceyy", { type: "custom", message: "custom message" });
      setError("experiencemm", { type: "custom", message: "custom message" });
      setError("lastSalaryDrawn", {
        type: "custom",
        message: "custom message",
      });
      setError("postHeld", { type: "custom", message: "custom message" });
      setError("company", { type: "custom", message: "custom message" });
      setError("reasonForleaving", {
        type: "custom",
        message: "custom message",
      });
    } else if (experienceyyWatch === "") {
      setError("experienceyy", { type: "custom", message: "custom message" });
    } else if (experiencemmWatch === "") {
      setError("experiencemm", { type: "custom", message: "custom message" });
    } else if (lastSalaryDrawneWatch === "") {
      setError("lastSalaryDrawn", {
        type: "custom",
        message: "custom message",
      });
    } else if (postHeldWatch === "") {
      setError("postHeld", { type: "custom", message: "custom message" });
    } else if (companyWatch === "") {
      setError("company", { type: "custom", message: "custom message" });
    } else if (reasonForleavingWatch === "") {
      setError("reasonForleaving", {
        type: "custom",
        message: "custom message",
      });
    }
    if (
      experienceyyWatch !== "" &&
      experiencemmWatch !== "" &&
      lastSalaryDrawneWatch !== "" &&
      postHeldWatch !== "" &&
      companyWatch !== "" &&
      reasonForleavingWatch !== ""
    ) {
      let Exparr = [...experienceData];
      let obj = {
        fromDate: format(fromDateWatch, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
        dateFrom: format(fromDateWatch, "yyyy-MM-dd"),
        toDate: format(toDateWatch, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
        dateTo: format(toDateWatch, "yyyy-MM-dd"),
        expYear:
          Number(experienceyyWatch) !== "" ? Number(experienceyyWatch) : 0,
        expMonths:
          Number(experiencemmWatch) !== "" ? Number(experiencemmWatch) : 0,
        lastDrawnSalary:
          Number(lastSalaryDrawneWatch) !== ""
            ? Number(lastSalaryDrawneWatch)
            : 0,
        postHeld: postHeldWatch,
        company: companyWatch,
        reasonForLeaving: reasonForleavingWatch,
      };
      const expAlreadyExists = experienceData.some(
        (item) =>
          item["fromDate"] === obj["fromDate"] &&
          item["toDate"] === obj["toDate"]
      );

      console.log("dependentAlreadyExists", expAlreadyExists);

      if (!expAlreadyExists) {
        Exparr.push(obj);
        handleExpReset();
      } else if (expAlreadyExists) {
        warningAlert("Record Already Exist");
      }

      setExperienceData(Exparr);
    }
  };

  //Post Object Dependent
  const handleDependentSubmit = () => {
    if (
      dependentFirstNameWatch === "" &&
      dependentMiddleNameWatch === "" &&
      dependentLastNameWatch === "" &&
      dependentRelationWatch === null &&
      dependentOccupationWatch === null &&
      dependentGenderWatch === null
    ) {
      setError("dependentFirstName", {
        type: "custom",
        message: "custom message",
      });
      setError("dependentMiddleName", {
        type: "custom",
        message: "custom message",
      });
      setError("dependentLastName", {
        type: "custom",
        message: "custom message",
      });
      setError("dependentGender", {
        type: "custom",
        message: "custom message",
      });
      setError("dependentAge", { type: "custom", message: "custom message" });
      setError("dependentRelation", {
        type: "custom",
        message: "custom message",
      });
      setError("dependentOccupation", {
        type: "custom",
        message: "custom message",
      });
    } else if (dependentFirstNameWatch === "") {
      setError("dependentFirstName", {
        type: "custom",
        message: "custom message",
      });
    } else if (dependentMiddleNameWatch === "") {
      setError("dependentMiddleName", {
        type: "custom",
        message: "custom message",
      });
    } else if (dependentLastNameWatch === "") {
      setError("dependentLastName", {
        type: "custom",
        message: "custom message",
      });
    } else if (dependentGenderWatch === "") {
      setError("dependentGender", {
        type: "custom",
        message: "custom message",
      });
    } else if (dependentRelationWatch === "") {
      setError("dependentRelation", {
        type: "custom",
        message: "custom message",
      });
    } else if (dependentOccupationWatch === "") {
      setError("dependentOccupation", {
        type: "custom",
        message: "custom message",
      });
    }
    if (
      dependentFirstNameWatch !== "" &&
      dependentMiddleNameWatch !== "" &&
      dependentLastNameWatch !== "" &&
      dependentRelationWatch !== null &&
      dependentOccupationWatch !== null &&
      dependentGenderWatch !== null
    ) {
      let dependentArr = [...dependentData];
      let obj = {
        firstName: dependentFirstNameWatch,
        middleName: dependentMiddleNameWatch,
        lastName: dependentLastNameWatch,
        birthDate: format(dateOfBirthsWatch, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
        ageYears:
          Number(dependentAgeWatch) !== "" ? Number(dependentAgeWatch) : 0,
        relationId: dependentRelationWatch.id,
        relationDec: dependentRelationWatch.label,
        occupationId: dependentOccupationWatch?.id,
        occupationDecs: dependentOccupationWatch.label,
        sexId: dependentGenderWatch.id,
        sexDec: dependentGenderWatch.label,
        applibility: MedicalVal,
      };

      const dependentAlreadyExists = dependentData.some(
        (item) =>
          item["firstName"] === obj["firstName"] &&
          item["lastName"] === obj["lastName"] &&
          item["relationDec"] === obj["relationDec"]
      );

      console.log("dependentAlreadyExists", dependentAlreadyExists);

      if (!dependentAlreadyExists) {
        dependentArr.push(obj);

        handleDepReset();
      } else if (dependentAlreadyExists) {
        warningAlert("Record Already Exist");
      }

      setDependentData(dependentArr);
    }
  };

  //Reset Function Eduction
  const handleReset = () => {
    setValue("degree", null);
    setValue("yearofPassing", "");
    setValue("university", "");
    setValue("classMarks", "");
    setValue("printApplicable", false);
  };

  //Handle Reset Function Experience
  const handleExpReset = () => {
    setValue("experienceyy", "");
    setValue("experiencemm", "");
    setValue("lastSalaryDrawn", "");
    setValue("postHeld", "");
    setValue("company", "");
    setValue("reasonForleaving", "");
  };

  //Handle Reset Function Dependent
  const handleDepReset = () => {
    setValue("dependentFirstName", "");
    setValue("dependentMiddleName", "");
    setValue("dependentLastName", "");
    setValue("dependentGender", null);
    setValue("dependentAge", "");
    setValue("dependentRelation", null);
    setValue("dependentOccupation", null);
  };



  //Fetch the Data Function
  React.useEffect(() => {
    if (props.edit === true) {
      console.log("props.editdatafetch", props.editdatafetch);

      let unitDoc = JSON.parse(props.editdatafetch.doctorUnits);
      console.log("unitDoc", unitDoc);
      let unitArr = [];
      for (let i = 0; i < unitDoc?.length; i++) {
        let unitObj = {
          id: unitDoc[i]?.unitId,
          value: unitDoc[i]?.unitId,
          label: unitDoc[i]?.unitDesc,
        };
        unitArr.push(unitObj);
        setValue("unit", unitArr);
      }

      let departmentDoc = JSON.parse(props.editdatafetch.docDepartments);
      console.log("departmentDoc", departmentDoc);
      let deparr = [];
      for (let i = 0; i < departmentDoc?.length; i++) {
        let departmentObj = {
          id: departmentDoc[i]?.depId,
          value: departmentDoc[i]?.depId,
          label: departmentDoc[i]?.docDesc,
        };
        deparr.push(departmentObj);
        setValue("unitDepartment", deparr);
      }
      let classdoc = JSON.parse(props.editdatafetch.docClassification);
      console.log("classdocclassdoc123", classdoc);
      let arr = [];
      for (let i = 0; i < classdoc?.length; i++) {
        let classificationObj = {
          id: classdoc[i]?.docClassifiId,
          value: classdoc[i]?.docClassifiId,
          label: classdoc[i]?.docDesc,
        };
        arr.push(classificationObj);
        setValue("unitClassification", arr);
      }
      let objReligion = {
        id: props.editdatafetch.religionId,
        value: props.editdatafetch.religionId,
        label: props.editdatafetch.religionDescription,
      };
      let objMotherTongue = {
        id: props.editdatafetch.motherTongueId,
        value: props.editdatafetch.motherTongueId,
        label: props.editdatafetch.motherTongueDescription,
      };
      let objBloodGroup = {
        id: props.editdatafetch.bloodGroupId,
        value: props.editdatafetch.bloodGroupId,
        label: props.editdatafetch.bloodGroupDescription,
      };
      let objMaritalStatus = {
        id: props.editdatafetch.maritalStatusId,
        value: props.editdatafetch.maritalStatusId,
        label: props.editdatafetch.maritalStatusDescription,
      };
      let objReferEntity = {
        id: props.editdatafetch.referEntityId,
        value: props.editdatafetch.referEntityId,
        label: props.editdatafetch.referEntityDescription,
      };
      let objDesignation = {
        id: props.editdatafetch.designationId,
        value: props.editdatafetch.designationId,
        label: props.editdatafetch.designationDescription,
      };
      let objClassification = {
        id: props.editdatafetch.docClassifiId,
        value: props.editdatafetch.docClassifiId,
        label: props.editdatafetch.docClassifiDesc,
      };
      let objDoctorType = {
        id: props.editdatafetch.docTypeId,
        value: props.editdatafetch.docTypeId,
        label: props.editdatafetch.docTypeDesc,
      };
      let objSpecialization = {
        id: props.editdatafetch.specialisationId,
        value: props.editdatafetch.specialisationId,
        label: props.editdatafetch.specialisationDesc,
      };
      let objsubSpecialization = {
        id: props.editdatafetch.subSpecialisationId,
        value: props.editdatafetch.subSpecialisationId,
        label: props.editdatafetch.subSpecialisationDesc,
      };
      let objCountry = {
        id: props.editdatafetch.pCountryId,
        value: props.editdatafetch.pCountryId,
        label: props.editdatafetch.pCountryDesc,
      };
      let objState = {
        id: props.editdatafetch.pStateId,
        value: props.editdatafetch.pStateId,
        label: props.editdatafetch.pStateDesc,
      };
      let objDistrict = {
        id: props.editdatafetch.pDistrictId,
        value: props.editdatafetch.pDistrictId,
        label: props.editdatafetch.pDistrictDesc,
      };
      let objTaluka = {
        id: props.editdatafetch.pDistrictId,
        value: props.editdatafetch.pDistrictId,
        label: props.editdatafetch.pDistrictDesc,
      };
      let objCity = {
        id: props.editdatafetch.pCityId,
        value: props.editdatafetch.pCityId,
        label: props.editdatafetch.pCityDesc,
      };
      let objArea = {
        id: props.editdatafetch.pAreaId,
        value: props.editdatafetch.pAreaId,
        label: props.editdatafetch.pAreaDesc,
      };
      let objlocalCountry = {
        id: props.editdatafetch.lCountryId,
        value: props.editdatafetch.lCountryId,
        label: props.editdatafetch.lCountryDesc,
      };
      let objlocalState = {
        id: props.editdatafetch.lStateId,
        value: props.editdatafetch.lStateId,
        label: props.editdatafetch.lStateDescription,
      };
      let objlocalDistrict = {
        id: props.editdatafetch.lDistrictId,
        value: props.editdatafetch.lDistrictId,
        label: props.editdatafetch.lDistrictDesc,
      };
      let objlocaltaluka = {
        id: props.editdatafetch.lDistrictId,
        value: props.editdatafetch.lDistrictId,
        label: props.editdatafetch.lDistrictDesc,
      };
      let objlocalCity = {
        id: props.editdatafetch.lCityId,
        value: props.editdatafetch.lCityId,
        label: props.editdatafetch.lCityDesc,
      };
      let objlocalArea = {
        id: props.editdatafetch.lAreaId,
        value: props.editdatafetch.lAreaId,
        label: props.editdatafetch.lAreaDesc,
      };
      let objBank = {
        id: props.editdatafetch.bankNameId,
        value: props.editdatafetch.bankNameId,
        label: props.editdatafetch.bankName,
      };
      let objMainDepartment = {
        id: props.editdatafetch.mainDepId,
        value: props.editdatafetch.mainDepId,
        label: props.editdatafetch.mainDepDesc,
      };
      let objPrefix = {
        id: props.editdatafetch.prefixId,
        value: props.editdatafetch.prefixId,
        label: props.editdatafetch.prefixDescription,
      };

      setValue("prefix", objPrefix)
      setValue("unitMainDepartment", objMainDepartment);
      setValue("doctorCode", props.editdatafetch.code);
      setValue("status", props.editdatafetch.activeStatus);
      setValue("privateOPD", props.editdatafetch.isPrivateOpd);
      setValue("privateOPD", props.editdatafetch.isPrivateOpd);
      setValue("OPD", props.editdatafetch.appOPD);
      setValue("IPD", props.editdatafetch.appIPD);
      setValue("investigation", props.editdatafetch.appInvestigation);
      setValue("noReference", props.editdatafetch.noreference);
      setValue("firstName", props.editdatafetch.firstName);
      setValue("middleName", props.editdatafetch.middleName);
      setValue("lastName", props.editdatafetch.lastName);
      setValue("yy", props.editdatafetch.ageYears);
      setValue("mm", props.editdatafetch.ageMonths);
      setValue("dd", props.editdatafetch.ageDays);
      setValue("religion", objReligion);
      setValue("motherTongh", objMotherTongue);
      setValue("bloodGroup", objBloodGroup);
      setValue("maritalStatus", objMaritalStatus);
      setValue("referEntity", objReferEntity);
      setValue("telephoneNo", props.editdatafetch.telephoneNo);
      setValue("mobileNo", props.editdatafetch.mobileNo);
      setValue("emailID", props.editdatafetch.emailId);
      setValue("passportNo", props.editdatafetch.passportNo);
      setValue("regNo", props.editdatafetch.regNo);
      setValue("mahRegNo", props.editdatafetch.mahaRegNo);

      // let tt = new Date(
      //   props.editdatafetch.mahaRegDate.toString().replaceAll("+00:00", "")
      // );

      // let tt = props.editdatafetch?.mahaRegDate
      //   ? new Date(
      //     props.editdatafetch.mahaRegDate
      //       .toString()
      //       .replaceAll("+00:00", "")
      //   )
      //   : null;

      // console.log(
      //   "the requiredDtaeString is :",
      //   new Date("2023-09-27T09:39:37.007")
      // );
      // setValue("renewalDate", tt);
      // // setRenewalToDate(tt);
      // let regDate = new Date(
      //   props.editdatafetch.regDate.toString().replaceAll("+00:00", "")
      // );
      // // setRenewalsToDate(regDate);
      // setValue("mahRenewalDate", regDate);
      // let dateofBirth = new Date(
      //   props.editdatafetch.dateOfBirth.toString().replaceAll("+00:00", "")
      // );
      // // setDateOfBirth(dateofBirth);
      // setValue("dateofBirth", dateofBirth);
      // let dateofAnniversary = new Date(
      //   props.editdatafetch.dateofAnniversary
      //     .toString()
      //     .replaceAll("+00:00", "")
      // );
      // // setDateOfAnniversary(dateofAnniversary);
      // setValue("dateOfAnniversary", dateofAnniversary);
      // let dateOfJoining = new Date(
      //   props.editdatafetch.dateOfJoining.toString().replaceAll("+00:00", "")
      // );
      // // setDateOfJoining(dateOfJoining);
      // setValue("dateOfJoining", dateOfJoining);


      // ✅ mahaRegDate
      let tt = props.editdatafetch?.mahaRegDate
        ? new Date(props.editdatafetch.mahaRegDate)
        : null;

      setValue("renewalDate", tt);

      // ✅ regDate
      let regDate = props.editdatafetch?.regDate
        ? new Date(props.editdatafetch.regDate)
        : null;

      setValue("mahRenewalDate", regDate);

      // ✅ dateOfBirth
      let dateofBirth = props.editdatafetch?.dateOfBirth
        ? new Date(props.editdatafetch.dateOfBirth)
        : null;

      setValue("dateofBirth", dateofBirth);

      // ✅ dateofAnniversary
      let dateofAnniversary = props.editdatafetch?.dateofAnniversary
        ? new Date(props.editdatafetch.dateofAnniversary)
        : null;

      setValue("dateOfAnniversary", dateofAnniversary);

      // ✅ dateOfJoining
      let dateOfJoining = props.editdatafetch?.dateOfJoining
        ? new Date(props.editdatafetch.dateOfJoining)
        : null;

      setValue("dateOfJoining", dateOfJoining);

      setValue("designation", objDesignation);
      setValue("classification", objClassification);
      setValue("doctorType", objDoctorType);
      setValue("specialization", objSpecialization);
      setValue("subSpecialization", objsubSpecialization);
      setValue("address", props.editdatafetch.pAddress);
      setValue("country", objCountry);
      setValue("state", objState);
      setValue("district", objDistrict);
      setValue("taluka", objTaluka);
      setValue("city", objCity);
      setValue("area", objArea);
      setValue("pinCode", props.editdatafetch.pPincode);

      setValue("localaddress", props.editdatafetch.lAddress);
      setValue("localCountry", objlocalCountry);
      setValue("localState", objlocalState);
      setValue("localDistrict", objlocalDistrict);
      setValue("localtaluka", objlocaltaluka);
      setValue("localCity", objlocalCity);
      setValue("localArea", objlocalArea);
      setValue("localPinCode", props.editdatafetch.lPincode);
      setValue("panNo", props.editdatafetch.docPanNo);
      setValue("ClinicName", props.editdatafetch.clinicName);
      setValue("BankName", objBank);
      setValue("branchName", props.editdatafetch.bankBranchName);
      setValue("ACNo", props.editdatafetch.bankAccNo);
      setValue("IFSCCode", props.editdatafetch.ifscMICRNo);
      setValue(
        "privateClinicContactNo",
        props.editdatafetch.clinicContactNumber
      );
      setValue("privateClinicAddress", props.editdatafetch.clinicAddress);
      if (props.editdatafetch.bankAccType === "C") {
        setValue("accountType", "current");
      } else if (props.editdatafetch.bankAccType === "S") {
        setValue("accountType", "saving");
      }
      if (props.editdatafetch.clinicType === "0") {
        setValue("Staff", "staff");
      } else if (props.editdatafetch.clinicType === "1") {
        setValue("Staff", "polyclinic");
      } else if (props.editdatafetch.clinicType === "2") {
        setValue("Staff", "nursing");
      }

      let eduArr = JSON.parse(props.editdatafetch.docEducation);
      let EducationArr = [];
      for (let i = 0; i < eduArr?.length; i++) {
        let obj = {
          qualificationId: eduArr[i]?.qualiId,
          qualificationDec: eduArr[i]?.qualiDesc,
          yearPassing: eduArr[i]?.yearOfPassing,
          university: eduArr[i]?.university,
          classOrMarks: eduArr[i]?.classOrMarks,
          printApplicable: eduArr[i]?.printApplicable,
        };
        EducationArr.push(obj);
        console.log("EducationArr", EducationArr);
        setEduData(EducationArr);
      }

      let dependentArr = JSON.parse(props.editdatafetch.docDependent);
      console.log("dependentArr", dependentArr);
      if (dependentArr?.applibility === "Y") {
        setValue("Medical", "Yes");
      } else if (dependentArr?.applibility === "N") {
        setValue("Medical", "No");
      }

      let newdepArr = [];
      for (let i = 0; i < dependentArr?.length; i++) {
        let obj = {
          firstName: dependentArr[i]?.depenFirstName,
          middleName: dependentArr[i]?.depenMiddleName,
          lastName: dependentArr[i]?.depenLastName,
          // sexId: dependentGenderWatch.id,
          // sexDec:dependentGenderWatch.label,
          birthDate: dependentArr[i]?.depenBirthDate,
          ageYears: dependentArr[i]?.depenAge,
          relationId: dependentArr[i]?.relationId,
          relationDec: dependentArr[i]?.relationDesc,
          occupationId: dependentArr[i]?.occId,
          occupationDecs: dependentArr[i]?.occDesc,
          sexId: dependentArr[i]?.genId,
          sexDec: dependentArr[i]?.genDesc,
        };
        newdepArr.push(obj);
        console.log("newdepArr", newdepArr);
        setDependentData(newdepArr);
      }


      let expArr = JSON.parse(props.editdatafetch.docExperience);
      let newExpArr = [];
      console.log("expArr", expArr);
      for (let i = 0; i < expArr?.length; i++) {
        let obj = {
          dateFrom: expArr[i]?.fromDate,
          dateTo: expArr[i]?.toDate,
          expYear: expArr[i]?.expYY,
          expMonths: expArr[i]?.expMM,
          lastDrawnSalary: expArr[i]?.lastDrawnSalary,
          postHeld: expArr[i]?.postHeld,
          company: expArr[i]?.company,
          reasonForLeaving: expArr[i]?.reasonForLeaving,
        };

        newExpArr.push(obj);

        setExperienceData(newExpArr);
      }
    }
  }, [props.editdatafetch]);

  const deleteRecord = (index, header) => {
    let numTempleData = [];
    if (index !== null) {
      if (header === "eduData") {
        numTempleData = [...eduData];
        numTempleData.splice(index, 1);
        console.log("numTempleData", numTempleData);
        setEduData(numTempleData);
      } else if (header === "expData") {
        numTempleData = [...experienceData];
        numTempleData.splice(index, 1);
        setExperienceData(numTempleData);
      } else if (header === "depData") {
        numTempleData = [...dependentData];
        numTempleData.splice(index, 1);
        setDependentData(numTempleData);
      }
    }
  };

  //BloodGroup Dropdown Api
  function bloodGroupApi() {
    bloodGroupDropdown().then((response) => {
      console.log("responseresponseresponse", response.data.result);
      setbloodGroupOption(response.data.result);
    });
  }

  //Marital Dropdown Api
  function maritalStatusApi() {
    maritalStatusDropdown().then((response) => {
      console.log("responseresponseresponse", response.data.result);
      setMaritalStatusOption(response.data.result);
    });
  }

  //ReferEntity Dropdown Api
  function referEntityApi() {
    referEntityDropdown().then((response) => {
      console.log("responseresponseresponse", response.data.result);
      setReferalEntityOption(response.data.result);
    });
  }

  //Specialization Dropdown Api
  function specializationApi() {
    specializationDropdown().then((response) => {
      console.log("responseresponseresponse", response.data.result);
      setSpecializationOption(response.data.result);
    });
  }

  //Prefix Dropdown Api
  function prefixDropdownApi() {
    prefixDropdown().then((response) => {
      console.log("responseresponseresponse", response.data.result);
      setPrefixOption(response.data.result);
    });
  }

  //Religion Dropdown Api
  function religionDropdownApi() {
    religionDropdown().then((response) => {
      console.log("responseresponseresponse", response.data.result);
      setReligionOption(response.data.result);
    });
  }

  //Mother-Tongh Dropdown Api
  function motherTonghDropdownApi() {
    motherTonghDropdown().then((response) => {
      console.log("responseresponseresponse", response.data.result);
      setMotherTonghOption(response.data.result);
    });
  }

  //Designation Dropdown Api
  function designationDropdownApi() {
    designationDropdown().then((response) => {
      console.log("responseresponseresponse", response.data.result);
      setDesignationOptions(response.data.result);
    });
  }

  //Classification Dropdown Api
  function classificationDropdownApi() {
    classificationDropdown().then((response) => {
      console.log("responseresponseresponse", response.data.result);
      setClassificationOption(response.data.result);
    });
  }

  // Doctor Type Dropdown Api
  function doctorTypeDropdownApi() {
    doctorTypeDropdown().then((response) => {
      console.log("responseresponseresponse", response.data.result);
      setDoctorTypeOption(response.data.result);
    });
  }

  //Sub-Specialization Dropdown Api
  function subSpecializationDropdownApi() {
    subSpecializationDropdown().then((response) => {
      console.log("responseresponseresponse", response.data.result);
      setSubSpecializationOption(response.data.result);
    });
  }

  //Degree Dropdown Api
  function degreeDropdownApi() {
    degreeDropdown().then((response) => {
      console.log("responseresponseresponse", response.data.result);
      setDegreeOption(response.data.result);
    });
  }

  // Bank Dropdown Api
  function bankDropdownApi() {
    bankDropdown().then((response) => {
      console.log("responseresponseresponse", response.data.result);
      setBankOption(response.data.result);
    });
  }

  //Country Dropdown Api
  function countryDropDownApi() {
    countryDropDown()
      .then((response) => {
        setCountryOption(response.data.result);
      })
      .catch((errors) => {
        console.log("errors", errors);
      });
  }

  // State Dropdown Api
  function stateDropdownApi(countryId) {
    if (typeof countryId === "number") {
      stateDropDown(countryId)
        .then((response) => {
          setStateOption(response.data.result);
        })
        .catch((errors) => {
          console.log("errors", errors);
        });
    }
  }

  //District Dropdown Api
  function districtDropDownApi(stateId) {
    if (typeof stateId === "number") {
      districtDropDown(stateId)
        .then((response) => {
          setDistrictOption(response.data.result);
        })
        .catch((errors) => {
          console.log("errors", errors);
        });
    }
  }

  //City Dropdown Api
  function cityDropDownApi(talukaId) {
    if (typeof talukaId === "number") {
      cityDropDown(talukaId)
        .then((response) => {
          console.log("response.data.result5555", response.data.result);
          setCityOption(response.data.result);
        })
        .catch((errors) => {
          console.log("errors", errors);
        });
    }
  }

  //Taluka Dropdown Api
  function talukaDropDownApi(districtId) {
    if (typeof districtId === "number") {
      talukaDropDown(districtId)
        .then((response) => {
          setTalukaOption(response.data.result);
        })
        .catch((errors) => {
          console.log("errors", errors);
        });
    }
  }

  //Area Dropdown Api
  function areaApi(cityId) {
    if (typeof cityId === "number") {
      areaDropDown(cityId)
        .then((response) => {
          setAreaOption(response.data.result);
        })
        .catch((response) => {
          console.log(response);
        });
    }
  }

  //Unit Dropdown API
  function unitDropDownApi() {
    unitDropDown()
      .then((response) => {
        setUnitOption(response.data.result);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  //Gender Dropdown Api
  function genderDropDownApi() {
    genderDropDown()
      .then((response) => {
        setGenderOption(response.data.result);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  //Relaion Dropdown Api
  function relationDropDownApi() {
    relationDropdown()
      .then((response) => {
        setRelationOption(response.data.result);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  //Occupation Dropdown Api
  function occupationDropDownApi() {
    occupationDropdown()
      .then((response) => {
        setOccupationOption(response.data.result);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  let unitArr = UnitWatch?.map((row) => row?.id);
  let ClassificationArr = unitClassificationWatch?.map((row) => row.id);
  let DepartmentArr = unitDepartmentWatch?.map((row) => row.id);

  //Autosearch API Function
  const handleChangeDep = (autoSearchString) => {
    console.log("autoSearchString", autoSearchString);
    if (autoSearchString !== "") {
      departmentDropdownSearch(autoSearchString)
        .then((response) => response.data)
        .then((res) => {
          console.log("res", res.result);
          setDepartMentOption(res.result);
        });
    }
  };

  const handleCheckSubmit = (e) => {
    if (e.target.value === true) {
      setValue("localaddress", addressWatch);
      setValue("localCountry", countryWatch);
      setValue("localState", stateWatch);
      setValue("localDistrict", districtWatch);
      setValue("localtaluka", talukaWatch);
      setValue("localCity", cityWatch);
      setValue("localArea", AreaWatch);
      setValue("localPinCode", pinCodeWatch);
    } else if (e.target.value === false) {
      setValue("localaddress", "");
      setValue("localCountry", null);
      setValue("localState", null);
      setValue("localDistrict", null);
      setValue("localtaluka", null);
      setValue("localCity", null);
      setValue("localArea", null);
      setValue("localPinCode", "");
    }
  };

  let unitMainDepartmentWatch = watch("unitMainDepartment")
  console.log("unitMainDepartmentWatch", unitMainDepartmentWatch);
  //Post Obj Final Function
  const onSubmitDataHandler = (data) => {
    console.log("datatatatat", data);
    if (props.edit === false) {
      // let obj = {
      //   id: 0,
      //   code: data.doctorCode,
      //   prefixId: data.prefix?.id,
      //   lastName: data.lastName,
      //   firstName: data.firstName,
      //   middleName: data.middleName,
      //   nationalityId: 0,
      //   religionId: data.religion?.id,
      //   motherTongueId: data.motherTongh?.id,
      //   bloodGroupId: data.bloodGroup?.id,
      //   maritalStatusId: data.maritalStatus?.id,
      //   birthDate: format(dateofBirthWatch, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
      //   ageYears: data.yy !== "" ? Number(data.yy) : 0,
      //   ageMonth: data.mm !== "" ? Number(data.mm) : 0,
      //   ageDays: data.dd !== "" ? Number(data.dd) : 0,
      //   panNo: data.panNo,
      //   passportNo: data.passportNo,
      //   designationId: data.designation?.id,
      //   dateOfJoining: format(
      //     dateOfJoiningWatch,
      //     "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
      //   ),
      //   dateofAnniversary: format(
      //     dateOfAnniversaryWatch,
      //     "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
      //   ),
      //   doctorTypeId: data.doctorType?.id,
      //   subSpecializationId: data.subSpecialization.id,
      //   specialisationId: data.specialization.id,
      //   classificationId: data.classification?.id,
      //   mobileNo: data.mobileNo,
      //   telNo: data.telephoneNo,
      //   emailId: data.emailID,
      //   regNo: data.regNo,
      //   mahRegNo: data.mahRegNo,
      //   regDate: format(renewalDateWatch, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
      //   mahRegDate: format(mahRenewalDateWatch, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
      //   bankNameId: data.BankName?.id,
      //   bankBranchName: data.branchName,
      //   bankAcNo: data.ACNo,
      //   ifscmicrNo: data.IFSCCode,
      //   accountType: account,
      //   resignationDt: "2023-09-28T04:17:49.983Z",
      //   clinicType: clinic,
      //   appOPD: data.OPD,
      //   appIPD: data.IPD,
      //   appProcedure: data.procedure,
      //   appInvestigation: data.investigation,
      //   privateOPD: data.privateOPD,
      //   status: data.status,
      //   addedBy: 154,
      //   updatedBy: 154,
      //   mainDepartmentId: unitMainDepartmentWatch?.id,
      //   noReference: data.noReference,
      //   unitIds: unitArr,
      //   classificationIds: ClassificationArr,
      //   depIds: DepartmentArr,
      //   doctorEducationRequestDtoList: eduData,
      //   doctorExperienceRequestDtoList: experienceData,
      //   doctorDependentRequestDtoList: dependentData,
      //   laddress: data.localaddress,
      //   lcountryId: data.localCountry?.id,
      //   lstateId: data.localState?.id,
      //   ldistrictId: data.localDistrict?.id,
      //   lcityId: data.localCity?.id,
      //   lareaId: data.localArea?.id,
      //   lpin: data.localPinCode,
      //   paddress: "string",
      //   pcountryId: data.country.id,
      //   pstateId: data.state.id,
      //   pdistrictId: data.district.id,
      //   pcityId: data.city.id,
      //   pareaId: data.area.id,
      //   ppin: data.pinCode,
      //   cname: data.ClinicName,
      //   caddress: data.privateClinicAddress,
      //   cphoneNo1: data.privateClinicContactNo,
      //   ptalukaId: data.taluka?.id,
      //   ltalukaId: data.localtaluka?.id,
      // };

      let obj = {
        id: props.edit ? props.editdatafetch?.docId : 0,
        code: data.doctorCode || "",

        prefixId: data.prefix?.id || 0,
        lastName: data.lastName || "",
        firstName: data.firstName || "",
        middleName: data.middleName || "",

        nationalityId: 0,

        docPhoto: photoData?.empPhotoBase64 || "",
        docSign: signData?.empSignBase64 || "",

        religionId: data.religion?.id || 0,
        motherTongueId: data.motherTongh?.id || 0,
        bloodGroupId: data.bloodGroup?.id || 0,
        maritalStatusId: data.maritalStatus?.id || 0,

        birthDate: dateofBirthWatch
          ? format(dateofBirthWatch, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
          : null,

        ageYears: Number(data.yy) || 0,
        ageMonth: Number(data.mm) || 0,
        ageDays: Number(data.dd) || 0,

        panNo: data.panNo || "",
        passportNo: data.passportNo || "",

        designationId: data.designation?.id || 0,

        dateOfJoining: dateOfJoiningWatch
          ? format(dateOfJoiningWatch, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
          : null,

        dateofAnniversary: dateOfAnniversaryWatch
          ? format(dateOfAnniversaryWatch, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
          : null,

        doctorTypeId: data.doctorType?.id || 0,
        subSpecializationId: data.subSpecialization?.id || 0,
        specialisationId: data.specialization?.id || 0,
        classificationId: data.classification?.id || 0,

        mobileNo: data.mobileNo || "",
        telNo: data.telephoneNo || "",
        emailId: data.emailID || "",

        regNo: data.regNo || "",
        mahRegNo: data.mahRegNo || "",

        regDate: renewalDateWatch
          ? format(renewalDateWatch, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
          : null,

        mahRegDate: mahRenewalDateWatch
          ? format(mahRenewalDateWatch, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
          : null,

        bankNameId: data.BankName?.id || 0,
        bankBranchName: data.branchName || "",
        bankAcNo: data.ACNo || "",
        ifscmicrNo: data.IFSCCode || "",

        accountType: account || "",
        resignationDt: new Date().toISOString(),

        clinicType: clinic || "",

        appOPD: data.OPD || false,
        appIPD: data.IPD || false,
        appProcedure: data.procedure || false,
        appInvestigation: data.investigation || false,
        privateOPD: data.privateOPD || false,

        status: data.status || false,

        addedBy: 154,
        updatedBy: 154,

        mainDepartmentId: unitMainDepartmentWatch?.id || 0,
        noReference: data.noReference || false,

        unitIds: unitArr || [],
        classificationIds: ClassificationArr || [],
        depIds: DepartmentArr || [],

        doctorEducationRequestDtoList: eduData || [],
        doctorExperienceRequestDtoList: experienceData || [],
        doctorDependentRequestDtoList: dependentData || [],

        laddress: data.localaddress || "",
        lcountryId: data.localCountry?.id || 0,
        lstateId: data.localState?.id || 0,
        ldistrictId: data.localDistrict?.id || 0,
        lcityId: data.localCity?.id || 0,
        lareaId: data.localArea?.id || 0,
        lpin: data.localPinCode || "",

        paddress: data.address || "",
        pcountryId: data.country?.id || 0,
        pstateId: data.state?.id || 0,
        pdistrictId: data.district?.id || 0,
        pcityId: data.city?.id || 0,
        pareaId: data.area?.id || 0,
        ppin: data.pinCode || "",

        cname: data.ClinicName || "",
        caddress: data.privateClinicAddress || "",
        cphoneNo1: data.privateClinicContactNo || "",

        ptalukaId: data.taluka?.id || 0,
        ltalukaId: data.localtaluka?.id || 0,
      };

      console.log("obj", obj);
      setFinalData(obj);
      setOpenPost(true);
    }
    if (props.edit === true) {
      // let updateObj = {
      //   id: props.editdatafetch?.docId,
      //   code: data.doctorCode,
      //   prefixId: data.prefix?.id,
      //   lastName: data.lastName,
      //   firstName: data.firstName,
      //   middleName: data.middleName,
      //   nationalityId: 0,
      //   religionId: data.religion?.id,
      //   motherTongueId: data.motherTongh?.id,
      //   bloodGroupId: data.bloodGroup?.id,
      //   maritalStatusId: data.maritalStatus?.id,
      //   birthDate: format(dateofBirthWatch, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
      //   ageYears: data.yy !== "" ? Number(data.yy) : 0,
      //   ageMonth: data.mm !== "" ? Number(data.mm) : 0,
      //   ageDays: data.dd !== "" ? Number(data.dd) : 0,
      //   panNo: data.panNo,
      //   passportNo: data.passportNo,
      //   designationId: data.designation?.id,
      //   dateOfJoining: format(
      //     dateOfJoiningWatch,
      //     "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
      //   ),
      //   dateofAnniversary: format(
      //     dateOfAnniversaryWatch,
      //     "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
      //   ),
      //   doctorTypeId: data.doctorType?.id,
      //   subSpecializationId: data.subSpecialization.id,
      //   specialisationId: data.specialization.id,
      //   classificationId: data.classification?.id,
      //   mobileNo: data.mobileNo,
      //   telNo: data.telephoneNo,
      //   emailId: data.emailID,
      //   regNo: data.regNo,
      //   mahRegNo: data.mahRegNo,
      //   regDate: format(renewalDateWatch, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
      //   mahRegDate: format(mahRenewalDateWatch, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
      //   bankNameId: data.BankName?.id,
      //   bankBranchName: data.branchName,
      //   bankAcNo: data.ACNo,
      //   ifscmicrNo: data.IFSCCode,
      //   accountType: account,
      //   resignationDt: "2023-09-28T04:17:49.983Z",
      //   clinicType: clinic,
      //   appOPD: data.OPD,
      //   appIPD: data.IPD,
      //   appProcedure: data.procedure,
      //   appInvestigation: data.investigation,
      //   privateOPD: data.privateOPD,
      //   status: data.status,
      //   addedBy: 154,
      //   updatedBy: 154,
      //   mainDepartmentId: unitMainDepartmentWatch?.id,
      //   noReference: data.noReference,
      //   unitIds: unitArr,
      //   classificationIds: ClassificationArr,
      //   depIds: DepartmentArr,
      //   doctorEducationRequestDtoList: eduData,
      //   doctorExperienceRequestDtoList: experienceData,
      //   doctorDependentRequestDtoList: dependentData,
      //   laddress: data.localaddress,
      //   lcountryId: data.localCountry?.id,
      //   lstateId: data.localState?.id,
      //   ldistrictId: data.localDistrict?.id,
      //   lcityId: data.localCity?.id,
      //   lareaId: data.localArea?.id,
      //   lpin: data.localPinCode,
      //   paddress: "string",
      //   pcountryId: data.country.id,
      //   pstateId: data.state.id,
      //   pdistrictId: data.district.id,
      //   pcityId: data.city.id,
      //   pareaId: data.area.id,
      //   ppin: data.pinCode,
      //   cname: data.ClinicName,
      //   caddress: data.privateClinicAddress,
      //   cphoneNo1: data.privateClinicContactNo,
      //   ptalukaId: data.taluka?.id,
      //   ltalukaId: data.localtaluka?.id,
      // };

      let updateObj = {
        id: props.edit ? props.editdatafetch?.docId : 0,
        code: data.doctorCode || "",

        prefixId: data.prefix?.id || 0,
        lastName: data.lastName || "",
        firstName: data.firstName || "",
        middleName: data.middleName || "",

        nationalityId: 0,

        religionId: data.religion?.id || 0,
        motherTongueId: data.motherTongh?.id || 0,
        bloodGroupId: data.bloodGroup?.id || 0,
        maritalStatusId: data.maritalStatus?.id || 0,

        birthDate: dateofBirthWatch
          ? format(dateofBirthWatch, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
          : null,

        ageYears: Number(data.yy) || 0,
        ageMonth: Number(data.mm) || 0,
        ageDays: Number(data.dd) || 0,

        panNo: data.panNo || "",
        passportNo: data.passportNo || "",

        designationId: data.designation?.id || 0,

        dateOfJoining: dateOfJoiningWatch
          ? format(dateOfJoiningWatch, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
          : null,

        dateofAnniversary: dateOfAnniversaryWatch
          ? format(dateOfAnniversaryWatch, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
          : null,

        docPhoto: photoData?.empPhotoBase64 || "",
        docSign: signData?.empSignBase64 || "",

        doctorTypeId: data.doctorType?.id || 0,
        subSpecializationId: data.subSpecialization?.id || 0,
        specialisationId: data.specialization?.id || 0,
        classificationId: data.classification?.id || 0,

        mobileNo: data.mobileNo || "",
        telNo: data.telephoneNo || "",
        emailId: data.emailID || "",

        regNo: data.regNo || "",
        mahRegNo: data.mahRegNo || "",

        regDate: renewalDateWatch
          ? format(renewalDateWatch, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
          : null,

        mahRegDate: mahRenewalDateWatch
          ? format(mahRenewalDateWatch, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
          : null,

        bankNameId: data.BankName?.id || 0,
        bankBranchName: data.branchName || "",
        bankAcNo: data.ACNo || "",
        ifscmicrNo: data.IFSCCode || "",

        accountType: account || "",
        resignationDt: new Date().toISOString(),

        clinicType: clinic || "",

        appOPD: data.OPD || false,
        appIPD: data.IPD || false,
        appProcedure: data.procedure || false,
        appInvestigation: data.investigation || false,
        privateOPD: data.privateOPD || false,

        status: data.status || false,

        addedBy: 154,
        updatedBy: 154,

        mainDepartmentId: unitMainDepartmentWatch?.id || 0,
        noReference: data.noReference || false,

        unitIds: unitArr || [],
        classificationIds: ClassificationArr || [],
        depIds: DepartmentArr || [],

        doctorEducationRequestDtoList: eduData || [],
        doctorExperienceRequestDtoList: experienceData || [],
        doctorDependentRequestDtoList: dependentData || [],

        laddress: data.localaddress || "",
        lcountryId: data.localCountry?.id || 0,
        lstateId: data.localState?.id || 0,
        ldistrictId: data.localDistrict?.id || 0,
        lcityId: data.localCity?.id || 0,
        lareaId: data.localArea?.id || 0,
        lpin: data.localPinCode || "",

        paddress: data.address || "",
        pcountryId: data.country?.id || 0,
        pstateId: data.state?.id || 0,
        pdistrictId: data.district?.id || 0,
        pcityId: data.city?.id || 0,
        pareaId: data.area?.id || 0,
        ppin: data.pinCode || "",

        docPhoto: photoData?.empPhotoBase64 || "",
        docSign: signData?.empSignBase64 || "",

        cname: data.ClinicName || "",
        caddress: data.privateClinicAddress || "",
        cphoneNo1: data.privateClinicContactNo || "",

        ptalukaId: data.taluka?.id || 0,
        ltalukaId: data.localtaluka?.id || 0,
      };

      console.log("update obj", updateObj);
      setOpenPut(true);
      setFinalData(updateObj);
    }
  };


  //Post / Add API Function
  function addRecord() {
    setOpenPost(false);
    setOpenPut(false);
    props.setOpenBackdrop(true);
    postDoctor(finalData)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200) {
          props.setOpenBackdrop(false);
          successAlert(res.message);
          props.setOpen(false);
          props.setEdit(false);
          props.populateTable();
          reset(defaultValues);
        }
      })
      .catch((error) => {
        props.setOpenBackdrop(false);
        errorAlert(error.message);
        setOpenPost(false);
        setOpenPut(false);
      });
    setFile(null);
    setUploadFile(null);
    setPhotoData(null);
    setSignData(null);
  }


  useEffect(() => {
    countryDropDownApi();
    stateDropdownApi(countryId);
    talukaDropDownApi(districtId);
    districtDropDownApi(stateId);
    cityDropDownApi(talukaId);
    areaApi(cityId);
  }, [countryId, stateId, districtId, cityId, talukaId]);

  useEffect(() => {
    bloodGroupApi();
    maritalStatusApi();
    referEntityApi();
    specializationApi();
    unitDropDownApi();
    prefixDropdownApi();
    religionDropdownApi();
    motherTonghDropdownApi();
    designationDropdownApi();
    classificationDropdownApi();
    doctorTypeDropdownApi();
    subSpecializationDropdownApi();
    degreeDropdownApi();
    bankDropdownApi();
    genderDropDownApi();
    relationDropDownApi();
    occupationDropDownApi();
  }, []);

  let prefixWatch = watch("prefix")
  console.log("prefixWatch", prefixWatch);

  return (
    <div>
      <Modal
        open={props.open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={ModalStyle} className="h-[90%] overflow-auto">
          <CancelPresentationIconButton
            onClick={() => {
              reset(defaultValues);
              props.handleClose();
              //   props.setEdit(false);
            }}
          />

          {/* <form onSubmit={handleSubmit(onSubmitDataHandler)}> */}

          <form onSubmit={handleSubmit(onSubmitDataHandler, onError)}>

            <fieldset className=" text-left  py-2 rounded mt-1  p-3">
              <legend className=" px-2 ml-3 lg:ml-0  text-gray-800 text-[18px] font-semibold text-start ">
                Doctor
              </legend>

              <div className="">
                <div>
                  <fieldset>
                    <div className="w-full my-1 ">
                      <Accordion
                        className="px-2"
                        sx={{
                          "& .MuiAccordionSummary-root": {
                            padding: "0px",
                            // marginBottom: "-1rem",
                          },

                          "& .MuiAccordionDetails-root": {
                            padding: "0px",
                          },
                          boxShadow: 1,
                        }}
                        defaultExpanded={true}
                      >
                        <AccordionSummary
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          expandIcon={
                            <ExpandMoreIcon
                            />
                          }
                          sx={{
                            "&.Mui-expanded": {
                              minHeight: 1,
                            },
                            "& .MuiAccordionSummary-content.Mui-expanded": {
                              margin: "auto",
                            },
                            "&.expanded": {
                              margin: "0px",
                            },
                          }}
                        >
                          <p className="text-start text-[16px] font-semibold pt-2 ">
                            Doctor
                          </p>
                        </AccordionSummary>
                        <div>
                          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 pt-2 pb-2">
                            <div>
                              <InputField
                                control={control}
                                name="doctorCode"
                                label="Doctor Code"
                                maxLength={10}
                              />
                            </div>
                            <div>
                              <CheckBoxField
                                control={control}
                                label="Active"
                                name="status"
                                checked={true}
                              />
                            </div>

                            <div className="flex gap-2">
                              <DropdownField
                                control={control}
                                name="prefix"
                                placeholder="Prefix"
                                sx={{ width: "100px" }}
                                dataArray={prefixOption}
                              />
                              <InputField
                                control={control}
                                name="firstName"
                                label="First Name*"
                                error={errors.firstName}
                              />
                            </div>
                            <div>
                              <InputField
                                control={control}
                                name="middleName"
                                label="Middle Name"
                              />
                            </div>
                            <div>
                              <InputField
                                control={control}
                                name="lastName"
                                label="Last Name*"
                                error={errors.lastName}
                              />
                            </div>
                            <div className="flex gap-2">


                              <DatePickerField
                                control={control}
                                name="dateofBirth"
                                label="Date Of Birth"
                                disableFuture
                                inputFormat="dd/MM/yyyy"
                                onAccept={(e) => {
                                  getAgeDOB(e);
                                }}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    fullWidth: true,
                                    sx: commonDatePickerSx,
                                  },
                                }}
                              />
                            </div>
                            <div className="grid grid-cols-3 gap-3">
                              <InputField
                                control={control}
                                type="number"
                                name="yy"
                                label="YY"
                              />
                              <InputField
                                type="number"
                                control={control}
                                name="mm"
                                label="MM"
                              />
                              <InputField
                                type="number"
                                control={control}
                                name="dd"
                                label="DD"
                              />
                            </div>
                            <div className="flex gap-2">
                              <DropdownField
                                control={control}
                                name="religion"
                                placeholder="Religion"
                                dataArray={religionOption}
                              />
                              <DropdownField
                                control={control}
                                name="motherTongh"
                                placeholder="Mother Tongh"
                                dataArray={motherTonghOption}
                              />
                            </div>
                            <div className="flex gap-2">
                              <DropdownField
                                control={control}
                                name="bloodGroup"
                                placeholder="Blood Group"
                                dataArray={bloodGroupOption}
                              />
                              <DropdownField
                                control={control}
                                name="maritalStatus"
                                placeholder="Marital Status"
                                dataArray={maritalStatusOption}
                              />
                            </div>
                            <div>
                              <InputField
                                control={control}
                                name="panNo"
                                label="Pan No"
                                error={errors.panNo}
                              />
                            </div>
                            <div>
                              <InputField
                                control={control}
                                name="telephoneNo"
                                label="Telephone No."
                                error={errors.telephoneNo}
                              />
                            </div>

                            <div>
                              <InputLimit
                                maxDigits={10}
                                control={control}
                                name="mobileNo"
                                label="Mobile No."
                                error={errors.mobileNo}
                              />
                            </div>

                            <div>
                              <InputField
                                control={control}
                                name="emailID"
                                label="Email ID"
                                error={errors.emailID}
                              />
                            </div>
                            <div>
                              <InputField
                                type="number"
                                control={control}
                                name="passportNo"
                                label="Passport No."
                                error={errors.passportNo}
                              />
                            </div>
                            <div className="flex gap-2">
                              <InputField
                                control={control}
                                name="regNo"
                                label="Reg. No."
                              />

                              <DatePickerField
                                control={control}
                                name="renewalDate"
                                label="Renewal Date"
                                disableFuture
                                // value={dateofBirth}
                                // onChange={(newValue) => {
                                //   console.log(
                                //     "selected date onchange",
                                //     newValue
                                //   );
                                //   setDateOfBirth(newValue);
                                // }}
                                inputFormat="dd/MM/yyyy"
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    fullWidth: true,
                                    sx: commonDatePickerSx,
                                  },
                                }}
                              />
                            </div>

                            <div className="flex gap-2">
                              <InputField
                                control={control}
                                name="mahRegNo"
                                label="Mah. Reg No."
                              />

                              <DatePickerField
                                control={control}
                                name="mahRenewalDate"
                                label="Mah Renewal Date"
                                disableFuture
                                // value={dateofBirth}
                                // onChange={(newValue) => {
                                //   console.log(
                                //     "selected date onchange",
                                //     newValue
                                //   );
                                //   setDateOfBirth(newValue);
                                // }}
                                inputFormat="dd/MM/yyyy"
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    fullWidth: true,
                                    sx: commonDatePickerSx,
                                  },
                                }}
                              />
                            </div>
                            <div>
                              <DropdownField
                                control={control}
                                name="designation"
                                placeholder="Designation"
                                dataArray={designationOption}
                              />
                            </div>
                            <div>
                              <DropdownField
                                control={control}
                                name="classification"
                                placeholder="Classification"
                                dataArray={classificationOption}
                              />
                            </div>
                            <div>
                              <DropdownField
                                control={control}
                                name="doctorType"
                                placeholder="Doctor Type"
                                dataArray={doctorTypeOption}
                              />
                            </div>

                            <div>
                              <DropdownField
                                control={control}
                                name="specialization"
                                placeholder="Specialization"
                                dataArray={specializationOption}
                              />
                            </div>
                            <div>
                              <DropdownField
                                control={control}
                                name="subSpecialization"
                                placeholder="Sub Specialization"
                                dataArray={subSpecializationOption}
                              />
                            </div>
                            <div className="flex gap-2">

                              <DatePickerField
                                control={control}
                                name="dateOfJoining"
                                label="Date Of Joining"
                                disableFuture
                                // value={dateofBirth}
                                // onChange={(newValue) => {
                                //   console.log(
                                //     "selected date onchange",
                                //     newValue
                                //   );
                                //   setDateOfBirth(newValue);
                                // }}
                                inputFormat="dd/MM/yyyy"
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    fullWidth: true,
                                    sx: commonDatePickerSx,
                                  },
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </Accordion>
                    </div>
                  </fieldset>
                </div>
                <div>
                  <fieldset>
                    <div className="w-full my-1 ">
                      <Accordion
                        className="px-2  "
                        sx={{
                          "& .MuiAccordionSummary-root": {
                            padding: "0px",
                            // marginBottom: "-1rem",
                          },

                          "& .MuiAccordionDetails-root": {
                            padding: "0px",
                          },
                          boxShadow: 1,
                        }}
                        defaultExpanded={true}
                      >
                        <AccordionSummary
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          expandIcon={
                            <ExpandMoreIcon
                            // sx={{
                            //   background: "#0B83A5",
                            //   margin: "5px 0",
                            //   color: "white",
                            //   minHeight: 0,
                            // }}
                            />
                          }
                          sx={{
                            "&.Mui-expanded": {
                              minHeight: 1,
                            },
                            "& .MuiAccordionSummary-content.Mui-expanded": {
                              margin: "auto",
                            },
                            "&.expanded": {
                              margin: "0px",
                            },
                          }}
                        >
                          <p className="text-start text-[16px] font-semibold pt-2">
                            Unit
                          </p>
                        </AccordionSummary>
                        <div>
                          <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 py-1">
                            <div>
                              <DropdownField
                                control={control}
                                name="unit"
                                placeholder="Unit"
                                isMulti={true}
                                dataArray={unitOption}
                              />
                            </div>
                            <div>
                              <DropdownField
                                control={control}
                                name="unitClassification"
                                placeholder="Classification"
                                isMulti={true}
                                dataArray={classificationOption}
                              />
                            </div>
                            <div>
                              <SearchDropdown
                                control={control}
                                name="unitDepartment"
                                placeholder="department"
                                isMulti={true}
                                handleInputChange={handleChangeDep}
                                dataArray={departmentOption}
                                error={errors.unitDepartment}
                                inputRef={{
                                  ...register("unitDepartment", {
                                    onChange: (e) => {
                                      console.log(
                                        "e.target.value",
                                        e.target.value
                                      );
                                      // handleDepSubmit();
                                    },
                                  }),
                                }}
                              />
                            </div>
                            <div>
                              <DropdownField
                                control={control}
                                name="unitMainDepartment"
                                placeholder="Main Department"
                                dataArray={unitDepartmentWatch}
                              />
                            </div>
                          </div>
                          <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 ">
                            <div>
                              <CheckBoxField
                                control={control}
                                name="privateOPD"
                                label="Private OPD"
                              />
                            </div>
                          </div>
                          <label className="text-[13px] font-semibold pt-2">
                            Applicable To
                          </label>
                          <div className="grid grid-cols-3 lg:grid-cols-5 py-1 pb-1 space-x-3">
                            <CheckBoxField
                              control={control}
                              name="OPD"
                              label=" OPD"
                            />
                            <CheckBoxField
                              control={control}
                              name="IPD"
                              label="IPD"
                            />
                            <CheckBoxField
                              control={control}
                              name="procedure"
                              label="Procedure"
                            />
                            <CheckBoxField
                              control={control}
                              name="investigation"
                              label="Investigation"
                            />
                            <CheckBoxField
                              control={control}
                              name="noReference"
                              label="No Reference"
                            />
                          </div>
                        </div>
                      </Accordion>
                    </div>
                  </fieldset>
                </div>
                <div>
                  <fieldset>
                    <div className="w-full my-1 ">
                      <Accordion
                        className="px-2  "
                        sx={{
                          "& .MuiAccordionSummary-root": {
                            padding: "0px",
                            // marginBottom: "-1rem",
                          },

                          "& .MuiAccordionDetails-root": {
                            padding: "0px",
                          },
                          boxShadow: 1,
                        }}
                        defaultExpanded={true}
                      >
                        <AccordionSummary
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          expandIcon={
                            <ExpandMoreIcon
                            // sx={{
                            //   background: "#0B83A5",
                            //   margin: "5px 0",
                            //   color: "white",
                            //   minHeight: 0,
                            // }}
                            />
                          }
                          sx={{
                            "&.Mui-expanded": {
                              minHeight: 1,
                            },
                            "& .MuiAccordionSummary-content.Mui-expanded": {
                              margin: "auto",
                            },
                            "&.expanded": {
                              margin: "0px",
                            },
                          }}
                        >
                          <p className="text-start text-[16px] font-semibold pt-2">
                            Address Detail
                          </p>
                        </AccordionSummary>
                        <div>
                          <div className="py-2">
                            <label className="text-[17px] font-semibold ">
                              Permeant Address{" "}
                            </label>
                          </div>
                          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 py-1">
                            <div className="col-span-2">
                              <InputField
                                control={control}
                                name="address"
                                label="Address*"
                                error={errors.address}
                              />
                            </div>
                            <div>
                              <DropdownField
                                control={control}
                                name="country"
                                placeholder="Country"
                                dataArray={countryOption}
                                inputRef={{
                                  ...register("country", {
                                    onChange: (e) => {
                                      setCountryId(e.target.value.id);
                                      console.log("country", e.target.value.id);
                                    },
                                  }),
                                }}
                              />
                            </div>
                            <div>
                              <DropdownField
                                control={control}
                                name="state"
                                placeholder="State"
                                dataArray={stateOption}
                                inputRef={{
                                  ...register("state", {
                                    onChange: (e) => {
                                      setStateId(e.target.value.id);
                                    },
                                  }),
                                }}
                              />
                            </div>

                            <div>
                              <DropdownField
                                control={control}
                                name="district"
                                placeholder="District"
                                dataArray={districtOption}
                                inputRef={{
                                  ...register("district", {
                                    onChange: (e) => {
                                      setDistrictId(e.target.value.id);
                                    },
                                  }),
                                }}
                              />
                            </div>
                            <div>
                              <DropdownField
                                control={control}
                                name="taluka"
                                placeholder="Taluka"
                                dataArray={talukaOption}
                                inputRef={{
                                  ...register("taluka", {
                                    onChange: (e) => {
                                      setTalukaId(e.target.value.id);
                                      console.log(
                                        "e.target.value.id",
                                        e.target.value.id
                                      );
                                    },
                                  }),
                                }}
                              />
                            </div>

                            <div>
                              <DropdownField
                                control={control}
                                name="city"
                                placeholder="City"
                                dataArray={cityOption}
                                inputRef={{
                                  ...register("city", {
                                    onChange: (e) => {
                                      setCityId(e.target.value.id);
                                      console.log(
                                        "e.target.value.id",
                                        e.target.value.id
                                      );
                                    },
                                  }),
                                }}
                              />
                            </div>
                            <div>
                              <DropdownField
                                control={control}
                                name="area"
                                placeholder="Area"
                                dataArray={areaOption}
                              />
                            </div>
                            <div>
                              <InputLimit
                                maxDigits={6}
                                control={control}
                                name="pinCode"
                                label="Pin Code"
                                error={errors.pinCode}
                              />
                            </div>
                            <label className="text-[13px] font-semibold pt-2">
                              Local Address{" "}
                            </label>
                            <div className="flex gap-2">
                              <CheckBoxField
                                control={control}
                                name="addresslocal"
                                label="Same as per permeant address"
                                // onClick={
                                //   handleCheckSubmit()
                                // }
                                inputRef={{
                                  ...register("addresslocal", {
                                    onChange: (e) => {
                                      console.log(
                                        "e.target.value",
                                        e.target.value
                                      );
                                      handleCheckSubmit(e);
                                    },
                                  }),
                                }}
                              />
                            </div>

                            <div className="col-span-2">
                              <InputField
                                control={control}
                                name="localaddress"
                                label="Address *"
                                error={errors.localaddress}
                              />
                            </div>
                            <div>
                              <DropdownField
                                control={control}
                                name="localCountry"
                                dataArray={countryOption}
                                placeholder="Country"
                                inputRef={{
                                  ...register("localCountry", {
                                    onChange: (e) => {
                                      setCountryId(e.target.value.id);
                                      console.log("country", e.target.value.id);
                                    },
                                  }),
                                }}
                              />
                            </div>
                            <div>
                              <DropdownField
                                control={control}
                                name="localState"
                                placeholder="State"
                                dataArray={stateOption}
                                inputRef={{
                                  ...register("localState", {
                                    onChange: (e) => {
                                      setStateId(e.target.value.id);
                                    },
                                  }),
                                }}
                              />
                            </div>

                            <div>
                              <DropdownField
                                control={control}
                                name="localDistrict"
                                placeholder="District"
                                dataArray={districtOption}
                                inputRef={{
                                  ...register("localDistrict", {
                                    onChange: (e) => {
                                      setDistrictId(e.target.value.id);
                                    },
                                  }),
                                }}
                              />
                            </div>
                            <div>
                              <DropdownField
                                control={control}
                                name="localtaluka"
                                placeholder="Taluka"
                                dataArray={talukaOption}
                                inputRef={{
                                  ...register("localtaluka", {
                                    onChange: (e) => {
                                      setTalukaId(e.target.value.id);
                                      console.log(
                                        "e.target.value.id",
                                        e.target.value.id
                                      );
                                    },
                                  }),
                                }}
                              />
                            </div>

                            <div>
                              <DropdownField
                                control={control}
                                name="localCity"
                                placeholder="City"
                                dataArray={cityOption}
                                inputRef={{
                                  ...register("localCity", {
                                    onChange: (e) => {
                                      setCityId(e.target.value.id);
                                      console.log(
                                        "e.target.value.id",
                                        e.target.value.id
                                      );
                                    },
                                  }),
                                }}
                              />
                            </div>
                            <div>
                              <DropdownField
                                control={control}
                                name="localArea"
                                placeholder="Area"
                                dataArray={areaOption}
                              />
                            </div>
                            <div>
                              <InputLimit
                                maxDigits={6}
                                control={control}
                                name="localPinCode"
                                label="Pin Code"
                                error={errors.pinCode}
                              />
                            </div>
                          </div>
                        </div>
                      </Accordion>
                    </div>
                  </fieldset>
                </div>
                <div>
                  <fieldset>
                    <div className="w-full my-1 ">
                      <Accordion
                        className="px-2 "
                        sx={{
                          "& .MuiAccordionSummary-root": {
                            padding: "0px",
                            // marginBottom: "-1rem",
                          },

                          "& .MuiAccordionDetails-root": {
                            padding: "0px",
                          },
                          boxShadow: 1,
                        }}
                        defaultExpanded={true}
                      >
                        <AccordionSummary
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          expandIcon={<ExpandMoreIcon />}
                          sx={{
                            "&.Mui-expanded": {
                              minHeight: 1,
                            },
                            "& .MuiAccordionSummary-content.Mui-expanded": {
                              margin: "auto",
                            },
                            "&.expanded": {
                              margin: "0px",
                            },
                          }}
                        >
                          <p className="text-start text-[16px] font-semibold py-2">
                            Private Clinic Details
                          </p>
                        </AccordionSummary>
                        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 ">
                          <div className=" col-span-2 space-x-3 flex">
                            <label className="font-semibold text-[14px] ">
                              Clinic Type :
                            </label>
                            <RadioField
                              control={control}
                              name="Staff"
                              dataArray={staffoption}
                            />
                          </div>
                          <div>
                            <InputField
                              control={control}
                              name="ClinicName"
                              label="Clinic Name"
                            />
                          </div>
                          <div>
                            <InputField
                              type="number"
                              control={control}
                              name="privateClinicContactNo"
                              label="contact No"
                              error={errors.privateClinicContactNo}
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-2 lg:grid-cols-4 py-1">
                          <div className="col-span-2">
                            <InputField
                              control={control}
                              name="privateClinicAddress"
                              label="Address*"
                              error={errors.privateClinicAddress}
                            />
                          </div>
                        </div>
                      </Accordion>
                    </div>
                  </fieldset>
                </div>

                <fieldset>
                  <div className="w-full my-1 ">
                    <Accordion
                      className="px-2  "
                      sx={{
                        "& .MuiAccordionSummary-root": {
                          padding: "0px",
                          // marginBottom: "-1rem",
                        },

                        "& .MuiAccordionDetails-root": {
                          padding: "0px",
                        },
                        boxShadow: 1,
                      }}
                      defaultExpanded={true}
                    >
                      <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        expandIcon={
                          <ExpandMoreIcon
                          // sx={{
                          //   background: "#0B83A5",
                          //   margin: "5px 0",
                          //   color: "white",
                          //   minHeight: 0,
                          // }}
                          />
                        }
                        sx={{
                          "&.Mui-expanded": {
                            minHeight: 1,
                          },
                          "& .MuiAccordionSummary-content.Mui-expanded": {
                            margin: "auto",
                          },
                          "&.expanded": {
                            margin: "0px",
                          },
                        }}
                      >
                        <p className="text-start text-[16px] font-semibold py-2">
                          Education
                        </p>
                      </AccordionSummary>
                      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 pb-2">
                        <div className="flex gap-2">
                          <DropdownField
                            control={control}
                            name="degree"
                            placeholder="Degree*"
                            dataArray={degreeOption}
                            error={errors.degree}
                          />
                          <InputLimit
                            maxDigits={4}
                            control={control}
                            name="yearofPassing"
                            label="Year of Passing "
                            sx={{ width: "200px" }}
                            error={errors.yearofPassing}
                          />
                        </div>
                        <div>
                          <InputField
                            control={control}
                            name="university"
                            label="University*"
                            error={errors.university}
                          />
                        </div>
                        <div className="flex gap-2 col-span-2">
                          <InputField
                            control={control}
                            name="classMarks"
                            label="Class/ Marks(%)"
                            sx={{ width: "200px" }}
                            error={errors.classMarks}
                          />
                          <CheckBoxField
                            control={control}
                            name="printApplicable"
                            label="Print Applicable"
                          />
                          <CommonButton
                            label="Add"
                            className="bg-green-500 text-white"
                            type="button"
                            onClick={() => {
                              handleEduOnSubmit();
                              handleReset();
                            }}
                          />
                        </div>
                      </div>

                      {eduData.length > 0 ? (
                        <CommonDynamicTableNew
                          dataResult={eduData}
                          highlightRow={false}
                          renderActions={RenderActions}
                          removeHeaders={["qualificationId"]}
                        />
                      ) : null}
                    </Accordion>
                  </div>
                </fieldset>

                <fieldset>
                  <div className="w-full my-1 ">
                    <Accordion
                      className="px-2  "
                      sx={{
                        "& .MuiAccordionSummary-root": {
                          padding: "0px",
                          // marginBottom: "-1rem",
                        },

                        "& .MuiAccordionDetails-root": {
                          padding: "0px",
                        },
                        boxShadow: 1,
                      }}
                      defaultExpanded={true}
                    >
                      <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        expandIcon={
                          <ExpandMoreIcon
                          // sx={{
                          //   background: "#0B83A5",
                          //   margin: "5px 0",
                          //   color: "white",
                          //   minHeight: 0,
                          // }}
                          />
                        }
                        sx={{
                          "&.Mui-expanded": {
                            minHeight: 1,
                          },
                          "& .MuiAccordionSummary-content.Mui-expanded": {
                            margin: "auto",
                          },
                          "&.expanded": {
                            margin: "0px",
                          },
                        }}
                      >
                        <p className="text-start text-[16px] font-semibold py-2">
                          Experience
                        </p>
                      </AccordionSummary>
                      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 ">
                        <div className="flex gap-2">
                          {/* <Controller
                            control={control}
                            name="fromDate"
                            rules={{
                              required: true,
                            }}
                            render={({ field }) => (
                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                              >
                                <DesktopDatePicker
                                  defaultValue={new Date()}
                                  label="From Date"
                                  value={fromToDate}
                                  sx={{
                                    svg: {
                                      color: "#1E3A8A",
                                      height: 22,
                                      width: "100%",
                                      marginRight: "16px",
                                    },
                                    backgroundColor: "white",
                                    overflow: "visible",
                                    "& .MuiInputBase-root": {
                                      height: "35.2px",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                      "& .MuiOutlinedInput-input": {
                                        // border: 0,
                                        fontSize: 14,
                                        height: "5px",
                                        width: "100%",
                                        // color: "red",
                                        // background: "red",
                                        borderColor: "#ffffff",
                                        overflow: "hidden",
                                      },
                                      "& .MuiFormLabel-root": {
                                        fontSize: "14px",
                                      },
                                    },
                                  }}
                                  format="dd/MM/yyyy"
                                  onChange={(newValue) => {
                                    console.log(
                                      "selected date onchange",
                                      newValue
                                    );
                                    setFromToDate(newValue);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      className="bg-white"
                                      name="fromDate"
                                      placeholder="From Date"
                                      fullWidth
                                      size="small"
                                      {...params}
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            )}
                          /> */}

                          <DatePickerField
                            control={control}
                            name="fromDate"
                            label="From Date"
                            disableFuture
                            // value={dateofBirth}
                            // onChange={(newValue) => {
                            //   console.log(
                            //     "selected date onchange",
                            //     newValue
                            //   );
                            //   setDateOfBirth(newValue);
                            // }}
                            inputFormat="dd/MM/yyyy"
                            slotProps={{
                              textField: {
                                size: "small",
                                fullWidth: true,
                                sx: commonDatePickerSx,
                              },
                            }}
                          />
                          {/* <Controller
                            control={control}
                            name="toDate"
                            rules={{
                              required: true,
                            }}
                            render={({ field }) => (
                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                              >
                                <DesktopDatePicker
                                  defaultValue={new Date()}
                                  label="To Date"
                                  value={toDate}
                                  sx={{
                                    svg: {
                                      color: "#1E3A8A",
                                      height: 22,
                                      width: "100%",
                                      marginRight: "16px",
                                    },
                                    backgroundColor: "white",
                                    overflow: "visible",
                                    "& .MuiInputBase-root": {
                                      height: "35.2px",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                      "& .MuiOutlinedInput-input": {
                                        // border: 0,
                                        fontSize: 14,
                                        height: "5px",
                                        width: "100%",
                                        // color: "red",
                                        // background: "red",
                                        borderColor: "#ffffff",
                                        overflow: "hidden",
                                      },
                                      "& .MuiFormLabel-root": {
                                        fontSize: "14px",
                                      },
                                    },
                                  }}
                                  format="dd/MM/yyyy"
                                  onChange={(newValue) => {
                                    console.log(
                                      "selected date onchange",
                                      newValue
                                    );
                                    SetToDate(newValue);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      className="bg-white"
                                      name="toDate"
                                      placeholder="To Date"
                                      fullWidth
                                      size="small"
                                      {...params}
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            )}
                          /> */}
                          <DatePickerField
                            control={control}
                            name="toDate"
                            label="To Date"
                            disableFuture
                            // value={dateofBirth}
                            // onChange={(newValue) => {
                            //   console.log(
                            //     "selected date onchange",
                            //     newValue
                            //   );
                            //   setDateOfBirth(newValue);
                            // }}
                            inputFormat="dd/MM/yyyy"
                            slotProps={{
                              textField: {
                                size: "small",
                                fullWidth: true,
                                sx: commonDatePickerSx,
                              },
                            }}
                          />
                        </div>

                        <div className="flex gap-2">
                          <InputField
                            control={control}
                            name="experienceyy"
                            label="YY"
                            sx={{ width: "80px" }}
                          />
                          <InputField
                            control={control}
                            name="experiencemm"
                            label="MM"
                            sx={{ width: "80px" }}
                          />
                          <InputField
                            control={control}
                            name="lastSalaryDrawn"
                            label="Last Salary Drawn"
                          />
                        </div>
                        <div>
                          <InputField
                            control={control}
                            name="postHeld"
                            label="Post Held*"
                            error={errors.postHeld}
                          />
                        </div>
                        <div className="">
                          <InputField
                            control={control}
                            name="company"
                            label="Company*"
                            error={errors.company}
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 py-1 pb-2">
                        <div className="">
                          <InputField
                            control={control}
                            name="reasonForleaving"
                            label="Reason For leaving"
                          />
                        </div>
                        <div>
                          <CommonButton
                            label="Add"
                            className="bg-green-500 text-white"
                            type="Button"
                            onClick={() => {
                              handleExperienceonSubmit();
                              handleExpReset();
                            }}
                          />
                        </div>
                      </div>
                      {experienceData.length > 0 ? (
                        <CommonDynamicTableNew
                          dataResult={experienceData}
                          highlightRow={false}
                          renderActions={RenderActionsExp}
                          removeHeaders={["fromDate", "toDate"]}
                        />
                      ) : null}
                    </Accordion>
                  </div>
                </fieldset>

                <fieldset>
                  <div className="w-full my-1 ">
                    <Accordion
                      className="px-2  "
                      sx={{
                        "& .MuiAccordionSummary-root": {
                          padding: "0px",
                          // marginBottom: "-1rem",
                        },

                        "& .MuiAccordionDetails-root": {
                          padding: "0px",
                        },
                        boxShadow: 1,
                      }}
                      defaultExpanded={true}
                    >
                      <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        expandIcon={
                          <ExpandMoreIcon
                          // sx={{
                          //   background: "#0B83A5",
                          //   margin: "5px 0",
                          //   color: "white",
                          //   minHeight: 0,
                          // }}
                          />
                        }
                        sx={{
                          "&.Mui-expanded": {
                            minHeight: 1,
                          },
                          "& .MuiAccordionSummary-content.Mui-expanded": {
                            margin: "auto",
                          },
                          "&.expanded": {
                            margin: "0px",
                          },
                        }}
                      >
                        <p className="text-start text-[16px] font-semibold py-2">
                          Bank
                        </p>
                      </AccordionSummary>
                      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
                        <div>
                          <DropdownField
                            control={control}
                            name="BankName"
                            dataArray={bankOption}
                            placeholder="Bank Name"
                          />
                        </div>
                        <div>
                          <InputField
                            control={control}
                            name="branchName"
                            label="Branch Name"
                          />
                        </div>
                        <div>
                          <InputField
                            type="number"
                            control={control}
                            name="ACNo"
                            label="A/C No."
                          />
                        </div>
                        <div>
                          <InputField
                            control={control}
                            name="IFSCCode"
                            label="IFSC Code"
                            error={errors.IFSCCode}
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 py-1">
                        <div className="col-span-2 flex gap-2 pt-1">
                          <label className="font-semibold text-[14px]">
                            Account Type :
                          </label>
                          <RadioField
                            control={control}
                            name="accountType"
                            dataArray={accountType}
                          />
                        </div>
                      </div>
                    </Accordion>
                  </div>
                </fieldset>

                <fieldset>
                  <div className="w-full my-1  ">
                    <Accordion
                      className="px-2 "
                      sx={{
                        "& .MuiAccordionSummary-root": {
                          padding: "0px",
                          // marginBottom: "-1rem",
                        },

                        "& .MuiAccordionDetails-root": {
                          padding: "0px",
                        },
                        boxShadow: 1,
                      }}
                      defaultExpanded={true}
                    >
                      <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        expandIcon={<ExpandMoreIcon />}
                        sx={{
                          "&.Mui-expanded": {
                            minHeight: 1,
                          },
                          "& .MuiAccordionSummary-content.Mui-expanded": {
                            margin: "auto",
                          },
                          "&.expanded": {
                            margin: "0px",
                          },
                        }}
                      >
                        <p className="text-start text-[16px] font-semibold py-2">
                          Dependent
                        </p>
                      </AccordionSummary>
                      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 ">
                        <div>
                          <InputField
                            control={control}
                            name="dependentFirstName"
                            label="First Name*"
                            error={errors.dependentFirstName}
                          />
                        </div>
                        <div>
                          <InputField
                            control={control}
                            name="dependentMiddleName"
                            label="Middle Name"
                            error={errors.dependentMiddleName}
                          />
                        </div>
                        <div>
                          <InputField
                            control={control}
                            name="dependentLastName"
                            label="Last Name*"
                            error={errors.dependentLastName}
                          />
                        </div>
                        <div>
                          <DropdownField
                            control={control}
                            name="dependentGender"
                            placeholder="Gender"
                            dataArray={genderOption}
                            error={errors.dependentGender}
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 py-1">
                        <div className="flex gap-2">
                          {/* <Controller
                            control={control}
                            name="dateOfBirths"
                            rules={{
                              required: true,
                            }}
                            render={({ field }) => (
                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                              >
                                <DesktopDatePicker
                                  defaultValue={new Date()}
                                  label="Date Of Birth"
                                  value={dateofBirths}
                                  sx={{
                                    svg: {
                                      color: "#1E3A8A",
                                      height: 22,
                                      width: "100%",
                                      marginRight: "16px",
                                    },
                                    backgroundColor: "white",
                                    overflow: "visible",
                                    "& .MuiInputBase-root": {
                                      height: "35.2px",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                      "& .MuiOutlinedInput-input": {
                                        // border: 0,
                                        fontSize: 14,
                                        height: "5px",
                                        width: "100%",
                                        // color: "red",
                                        // background: "red",
                                        borderColor: "#ffffff",
                                        overflow: "hidden",
                                      },
                                      "& .MuiFormLabel-root": {
                                        fontSize: "14px",
                                      },
                                    },
                                  }}
                                  format="dd/MM/yyyy"
                                  onChange={(newValue) => {
                                    console.log(
                                      "selected date onchange",
                                      newValue
                                    );
                                    setDateOfBirths(newValue);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      className="bg-white"
                                      name="dateOfBirth"
                                      placeholder="Date Of Birth"
                                      fullWidth
                                      size="small"
                                      {...params}
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            )}
                          /> */}
                          <DatePickerField
                            control={control}
                            name="dateOfBirths"
                            label="Birth Date"
                            disableFuture
                            // value={dateofBirth}
                            // onChange={(newValue) => {
                            //   console.log(
                            //     "selected date onchange",
                            //     newValue
                            //   );
                            //   setDateOfBirth(newValue);
                            // }}
                            inputFormat="dd/MM/yyyy"
                            slotProps={{
                              textField: {
                                size: "small",
                                fullWidth: true,
                                sx: commonDatePickerSx,
                              },
                            }}
                          />
                        </div>
                        <div>
                          <InputField
                            type="number"
                            control={control}
                            name="dependentAge"
                            label="Age (Years)"
                            error={errors.dependentAge}
                          />
                        </div>
                        <div>
                          <DropdownField
                            control={control}
                            name="dependentRelation"
                            placeholder="Relation"
                            dataArray={relationOption}
                            error={errors.dependentRelation}
                          />
                        </div>
                        <div>
                          <DropdownField
                            control={control}
                            name="dependentOccupation"
                            placeholder="Occupation"
                            dataArray={occupationOption}
                            error={errors.dependentOccupation}
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-3 lg:grid-cols-3 gap-2 py-1">
                        <div className=" gap-2 col-span-2 ">
                          <div className=" flex space-x-2 ">
                            <label className="font-semibold text-[14px]">
                              Medical Allowance Applicability :
                            </label>
                            <RadioField
                              control={control}
                              name="Medical"
                              dataArray={MedicalAllowance}
                            />
                            <CommonButton
                              label="Add"
                              className="bg-green-500 text-white"
                              type="Button"
                              onClick={() => {
                                handleDependentSubmit();
                                handleDepReset();
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      {dependentData.length > 0 ? (
                        <CommonDynamicTableNew
                          dataResult={dependentData}
                          highlightRow={false}
                          renderActions={RenderActionsDep}
                          removeHeaders={[
                            "relationId",
                            "occupationId",
                            "sexId",
                          ]}
                        />
                      ) : null}
                    </Accordion>
                  </div>
                </fieldset>
                <fieldset>
                  <div className="w-full my-1 ">
                    <Accordion
                      className="px-2  "
                      sx={{
                        "& .MuiAccordionSummary-root": {
                          padding: "0px",
                          // marginBottom: "-1rem",
                        },

                        "& .MuiAccordionDetails-root": {
                          padding: "0px",
                        },
                        boxShadow: 1,
                      }}
                      defaultExpanded={true}
                    >
                      <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        expandIcon={<ExpandMoreIcon />}
                        sx={{
                          "&.Mui-expanded": {
                            minHeight: 1,
                          },
                          "& .MuiAccordionSummary-content.Mui-expanded": {
                            margin: "auto",
                          },
                          "&.expanded": {
                            margin: "0px",
                          },
                        }}
                      >
                        <p className="text-start text-[16px] font-semibold pt-2">
                          Other
                        </p>
                      </AccordionSummary>
                      <div>
                        <lable className="font-semibold text-[13px]">
                          Photo And Signature Upload setOpenPost{" "}
                        </lable>
                        {/* <div className="grid grid-cols-2 lg:grid-cols-2 pb-[8px]">
                          <div className="flex gap-2 ">
                            {file ? (
                              <div className="">
                                <CancelPresentationIconButton
                                  onClick={() => {
                                    setFile({});
                                  }}
                                />
                                <img
                                  src={file}
                                  alt=""
                                  className="w-[120px] h-[120px]"
                                />
                              </div>
                            ) : (
                              <div className=" ">
                                <Photo />
                              </div>
                            )}
                            <div className="pt-10">
                              <input
                                type="file"
                                onChange={(e) => handleChange(e)}
                                ref={inputFile}
                              />
                            </div>
                          </div>

                          <div className="flex gap-2 ">
                            {uploadfile ? (
                              <div className="pt-1">
                                <CancelPresentationIconButton
                                  onClick={() => {
                                    setUploadFile({});
                                  }}
                                />
                                <img
                                  src={uploadfile}
                                  alt=""
                                  className="w-[350px] h-[100px]"
                                />
                              </div>
                            ) : (
                              <div className="pt-1">
                                <Sign />
                              </div>
                            )}
                            <div className="pt-10">
                              <input
                                type="file"
                                onChange={(e) => handleChangeClick(e)}
                                ref={inputFile}
                              />
                            </div>
                          </div>
                        </div> */}

                        <div className="grid grid-cols-2 lg:grid-cols-2 pb-[8px]">
                          <div className="flex gap-2 ">
                            {file ? (
                              <div>
                                <CancelPresentationIconButton
                                  onClick={() => {
                                    setFile(null);   // ✅ FIX
                                  }}
                                />
                                <img
                                  src={file}
                                  alt=""
                                  className="w-[120px] h-[120px]"
                                />
                              </div>
                            ) : props.editdatafetch?.photoBase64 ? (
                              <img
                                src={`data:image/png;base64,${props.editdatafetch.photoBase64}`}
                                className="w-[120px] h-[120px]"
                                alt=""
                              />
                            ) : (
                              <Photo />
                            )}
                            <div className="pt-10">
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleChange(e)}
                                ref={inputFile}
                              />
                            </div>
                          </div>

                          <div className="flex gap-2 ">
                            {uploadfile ? (
                              <div>
                                <CancelPresentationIconButton
                                  onClick={() => {
                                    setUploadFile(null);   // ✅ FIX
                                  }}
                                />
                                <img
                                  src={uploadfile}
                                  className="w-[350px] h-[100px]"
                                  alt=""
                                />
                              </div>
                            ) : props.editdatafetch?.signBase64 ? (
                              <img
                                src={`data:image/png;base64,${props.editdatafetch.signBase64}`}
                                className="w-[350px] h-[100px]"
                                alt=""
                              />
                            ) : (
                              <Sign />
                            )}
                            <div className="pt-10">
                              <input
                                type="file"
                                onChange={(e) => handleChangeClick(e)}
                                ref={inputFile}
                              />
                            </div>
                          </div>
                        </div>

                        <hr className="bg-blue-900"></hr>
                        <label className="font-semibold">
                          Attachment to Other Hospital
                        </label>
                        <div className="grid grid-cols-2 lg:grid-cols-2 pb-[8px] gap-2">
                          <div className="">
                            <div className="">
                              <InputField
                                control={control}
                                name="hospitalName"
                                label="Hospital Name"
                              />
                            </div>
                          </div>
                          <div>
                            <CommonButton
                              label="Add"
                              className="bg-green-500 text-white"
                              type="button"
                            // onClick={() => {
                            //   handleEduOnSubmit();
                            //   handleReset()
                            // }}
                            />
                          </div>
                        </div>
                      </div>
                    </Accordion>
                  </div>
                </fieldset>
                <div>
                  {props.edit === false ? (
                    <div className="flex justify-end gap-2 pt-2">
                      <CommonButton
                        label="Reset"
                        className=" border border-red-600 text-red-600"
                        type="button"
                        onClick={() => reset(defaultValues)}
                      />
                      <CommonButton
                        label="Save"
                        className="bg-green-500 text-white"
                        type="Submit"
                        onClick={() => {
                          // handlElectricalDescriptionSubmit();
                        }}
                      />
                    </div>
                  ) : (
                    <div className="flex justify-end gap-2 pt-2">
                      <CommonButton
                        label="Cancel"
                        className=" border border-red-600 text-red-600"
                        type="button"
                        onClick={() => {
                          reset(defaultValues);
                          props.handleClose();
                        }}
                      />
                      <CommonButton
                        label="Update"
                        className="bg-green-500 text-white"
                        type="Submit"
                        onClick={() => {
                          // handlElectricalDescriptionSubmit();
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </fieldset>
            <CommonBackDrop openBackdrop={props.openBackdrop} />
          </form>
        </Box>
      </Modal>
      <ConfirmationModal
        confirmationOpen={openPost}
        confirmationHandleClose={handleClosePost}
        confirmationSubmitFunc={addRecord}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure want to add this record ?"
        confirmationButtonMsg="Add"
      />
      <ConfirmationModal
        confirmationOpen={openPut}
        confirmationHandleClose={handleClosePut}
        confirmationSubmitFunc={addRecord}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure want to update this record ?"
        confirmationButtonMsg="Update"
      />
    </div>
  );
}
